const sliderInit = (isUpdate) => {
	if (
		document.querySelectorAll('.js-media-list, .js-media-list-mobile') &&
		document.querySelectorAll('.js-media-list, .js-media-list-mobile').length > 0
	) {
		document.querySelectorAll('.js-media-list, .js-media-list-mobile').forEach((elem, index) => {
			let prevButton = elem.querySelector('.product__slider-nav .swiper-button-prev')
			let nextButton = elem.querySelector('.product__slider-nav .swiper-button-next')
			let pagination = elem.querySelector('.product__pagination')
			const initialSlide = elem.dataset.currentIndex || 0

			if (elem.swiper) {
				elem.swiper.destroy(true, true)
			}

			let slider = new Swiper(elem, {
				initialSlide: initialSlide,
				slidesPerView:
					elem
						.closest('.product__outer')
						.classList.contains('product__gallery--full_screen_top-mobile') ||
					elem
						.closest('.product__outer')
						.classList.contains('product__gallery--single_aside-mobile') ||
					elem
						.closest('.product__outer')
						.classList.contains('product__gallery--thumbs_aside-mobile')
						? 1
						: 1.1,
				spaceBetween: elem
					.closest('.product__outer')
					.classList.contains('product__gallery--multiple_top-mobile')
					? 0
					: 1,
				autoHeight: true,
				speed: 500,
				freeMode: {
					enabled:
						window.innerWidth < 750
							? elem
									.closest('.product__outer')
									.classList.contains('product__gallery--multiple_top-mobile')
							: elem.closest('.product__outer').classList.contains('product__outer--multiple-top'),
					sticky: true,
				},
				navigation: {
					nextEl: nextButton,
					prevEl: prevButton,
				},
				pagination: {
					el: pagination,
					type: 'bullets',
					clickable: true,
				},
				thumbs: {
					swiper: elem.nextElementSibling.querySelector('.js-media-sublist')?.swiper
						? elem.nextElementSibling.querySelector('.js-media-sublist').swiper
						: '',
				},
				breakpoints: {
					750: {
						slidesPerView:
							elem.closest('.product__outer').classList.contains('product__outer--full-screen') ||
							elem.closest('.product__outer').classList.contains('product__outer--single-aside') ||
							elem.closest('.product__outer').classList.contains('product__outer--thumbs-aside')
								? 1
								: 1.1,
						spaceBetween: elem
							.closest('.product__outer')
							.classList.contains('product__outer--multiple-top')
							? 0
							: 1,
					},
					// Fixed
					990: {
						slidesPerView:
							elem.closest('.product__outer').classList.contains('product__outer--full-screen') ||
							elem.closest('.product__outer').classList.contains('product__outer--single-aside') ||
							elem.closest('.product__outer').classList.contains('product__outer--thumbs-aside')
								? 1
								: 2.37,
					},
				},
				on: {
					afterInit: function (swiper) {
						if (
							(document.querySelector('.product__outer--multiple-top') &&
								window.innerWidth >= 750) ||
							(document.querySelector('.product__gallery--multiple_top-mobile') &&
								window.innerWidth < 750)
						) {
							document.querySelectorAll('.product__media-toggle').forEach((elem, index) => {
								elem.addEventListener('click', (e) => {
									var target = e.currentTarget

									if (
										document.querySelector('.js-popup-slider') &&
										document.querySelector('.js-popup-slider').swiper
									) {
										document.querySelector('.js-popup-slider').swiper.slideTo(index)
									}
								})
							})
						}
					},
					slideChangeTransitionStart: function () {
						const slider =
							document.querySelector('.js-media-list') ||
							document.querySelector('.js-media-list-mobile')
						if (
							document.querySelector('.js-media-sublist') &&
							document.querySelector('.js-media-sublist').swiper
						) {
							document.querySelector('.js-media-sublist').swiper.slideTo(slider.swiper.activeIndex)
						}
					},
					slideChange: function () {
						window.pauseAllMedia()
						this.params.noSwiping = false

						if (
							document.querySelector('.js-popup-slider') &&
							document.querySelector('.js-popup-slider').swiper &&
							!(
								(document.querySelector('.product__outer--multiple-top') &&
									window.innerWidth >= 750) ||
								(document.querySelector('.product__gallery--multiple_top-mobile') &&
									window.innerWidth < 750)
							)
						) {
							document.querySelector('.js-popup-slider').swiper.slideTo(this.activeIndex)
						}
					},
					slideChangeTransitionEnd: function () {
						if (this.slides[this.activeIndex].querySelector('model-viewer')) {
							this.slides[this.activeIndex]
								.querySelector('.shopify-model-viewer-ui__button--poster')
								.removeAttribute('hidden')
						}
					},
					touchStart: function () {
						if (this.slides[this.activeIndex].querySelector('model-viewer')) {
							if (
								!this.slides[this.activeIndex]
									.querySelector('model-viewer')
									.classList.contains('shopify-model-viewer-ui__disabled')
							) {
								this.params.noSwiping = true
								this.params.noSwipingClass = 'swiper-slide'
							} else {
								this.params.noSwiping = false
							}
						}
					},
				},
			})

			if (isUpdate) {
				setTimeout(function () {
					slider.update()
				}, 800)
			}
		})

		const pageResizeObserve = new ResizeObserver((entries) => {
			const [entry] = entries

			if (entry.contentRect.width < 750) {
				const slider = entry.target.querySelector('.js-media-list')
				const sliderMobile = entry.target.querySelector('.js-media-list-mobile')

				if (
					slider &&
					slider.swiper &&
					(entry.target.querySelector('.product__gallery--static_multicolumns_aside-mobile') ||
						entry.target.querySelector('.product__gallery--static_column_aside-mobile'))
				) {
					slider.swiper.destroy(true, true)
				}

				if (sliderMobile && !slider) {
					if (!sliderMobile.swiper) {
						subSliderInit(true)
						sliderInit(true)
						popupSliderInit(true)
					}
				}
			} else {
				const slider = entry.target.querySelector('.js-media-list')
				const sliderMobile = entry.target.querySelector('.js-media-list-mobile')

				if (sliderMobile && sliderMobile.swiper && !slider) {
					sliderMobile.swiper.destroy(true, true)
				}

				if (slider) {
					if (!slider.swiper) {
						subSliderInit(true)
						sliderInit(true)
						popupSliderInit(true)
					}
				}
			}
		})

		if (document.querySelector('.product-section'))
			pageResizeObserve.observe(document.querySelector('.product-section'))
	}
}

const subSliderInit = (isUpdate) => {
	if (
		document.querySelectorAll('.js-media-sublist') &&
		document.querySelectorAll('.js-media-sublist').length > 0
	) {
		document.querySelectorAll('.js-media-sublist').forEach((elem, index) => {
			if (elem.swiper) elem.swiper.destroy()
			const isThumbsAside = elem.classList.contains('sublist-thumbs-aside')

			const breakpoint = isThumbsAside ? 1100 : 990

			let subSlider = new Swiper(elem, {
				slidesPerView: 4,
				spaceBetween: 8,
				direction: 'horizontal',
				direction: 'horizontal',
				freeMode: false,
				watchSlidesProgress: true,
				watchSlidesVisibility: true,
				autoHeight: true,
				on: {
					afterInit: function () {
						//this.params.slidesPerView = this.slides.length === 2 ? 2 : 3;
					},
					touchEnd: function (s, e) {
						let range = 5
						let diff = (s.touches.diff = s.isHorizontal()
							? s.touches.currentX - s.touches.startX
							: s.touches.currentY - s.touches.startY)
						if (diff < range || diff > -range) s.allowClick = true
					},
				},
				//transitionStart: function () {
				//	document
				//		.querySelector(".js-media-list")
				//		.swiper.slideTo(
				//			document.querySelector(".js-media-sublist").swiper.activeIndex,
				//		);
				//},
				breakpoints: {
					[breakpoint]: {
						spaceBetween: 4,
						direction: 'vertical',
						slidesPerView: 'auto',
						direction: 'vertical',
						slidesPerView: 'auto',
					},
				},
			})

			const sliderResizeObserve = new ResizeObserver((entries) => {
				const [entry] = entries
				// Fixed
				if (entry.contentRect.width >= breakpoint) {
					setTimeout(() => {
						const sliders = document.querySelectorAll('.js-media-list, .js-media-list-mobile')
						const thumbs = document.querySelectorAll('.product__media-sublist')

						const sliderHeight = sliders[index].getBoundingClientRect().height
						thumbs[index].style.height = `${sliderHeight - 1}px`
					}, 400)
				}
			})

			if (document.querySelector('.product-section'))
				sliderResizeObserve.observe(document.querySelector('.product-section'))
			if (document.querySelector('.product-section'))
				sliderResizeObserve.observe(document.querySelector('.product-section'))

			document.querySelectorAll('.featured-product-section').forEach((section) => {
				sliderResizeObserve.observe(section)
			})

			if (isUpdate) {
				setTimeout(function () {
					subSlider.update()
				}, 800)
			}
		})
	}
}

const popupSliderInit = (isUpdate) => {
	if (document.querySelector('.js-popup-slider')) {
		let popupSlider = new Swiper(document.querySelector('.js-popup-slider'), {
			slidesPerView: 1,
			navigation: {
				nextEl: '.product-media-modal .product__slider-nav .swiper-button-next',
				prevEl: '.product-media-modal .product__slider-nav .swiper-button-prev',
			},
			pagination: {
				el: '.product-media-modal .product__pagination',
				type: 'bullets',
				clickable: true,
			},
			on: {
				afterInit: function () {
					if (
						document.querySelector('.product__outer--static-multicolumns-aside') ||
						document.querySelector('.product__outer--static-column-aside') ||
						document.querySelector('.product__gallery--static_multicolumns_aside-mobile') ||
						document.querySelector('.product__gallery--static_column_aside-mobile')
					) {
						document
							.querySelectorAll('.product__media-list .product__media-toggle')
							.forEach((elem, index) => {
								elem.addEventListener('click', (e) => {
									if (
										document.querySelector('.js-popup-slider') &&
										document.querySelector('.js-popup-slider').swiper
									) {
										document.querySelector('.js-popup-slider').swiper.slideTo(index)
									}
								})
							})
					}
				},
				slideChange: function () {
					window.pauseAllMedia()
					this.params.noSwiping = false
					document.querySelector('.product-media-modal__content').classList.remove('zoom')
				},
				touchMove: function () {
					document.querySelector('.product-media-modal__content').classList.remove('zoom')
				},
				slideChangeTransitionEnd: function () {
					if (this.slides[this.activeIndex].querySelector('model-viewer')) {
						this.slides[this.activeIndex]
							.querySelector('.shopify-model-viewer-ui__button--poster')
							.removeAttribute('hidden')
					}
				},
				touchStart: function () {
					if (this.slides[this.activeIndex].querySelector('model-viewer')) {
						if (
							!this.slides[this.activeIndex]
								.querySelector('model-viewer')
								.classList.contains('shopify-model-viewer-ui__disabled')
						) {
							this.params.noSwiping = true
							this.params.noSwipingClass = 'swiper-slide'
						} else {
							this.params.noSwiping = false
						}
					}
				},
			},
		})

		if (isUpdate) {
			setTimeout(function () {
				popupSlider.update()
			}, 800)
		}
	}
}

if (navigator.userAgent.indexOf('iPhone') > -1) {
	document
		.querySelector('[name=viewport]')
		.setAttribute('content', 'width=device-width, initial-scale=1, maximum-scale=1')
}

function getFocusableElements(container) {
	return Array.from(
		container.querySelectorAll(
			"summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
		),
	)
}

;(function () {
	const headerDrawer = document.querySelector('header-drawer')
	if (!headerDrawer) return

	const drawerTabs = document.querySelectorAll('.mega-menu__tab')
	if (!drawerTabs) return

	drawerTabs.forEach((tab) => {
		tab.addEventListener('click', () => {
			tab.classList.toggle('tab--active')
			const tabToggler = tab.querySelector('.mega-menu__tab-toggler')
			const initialExpanded = JSON.parse(tabToggler.getAttribute('aria-expanded'))
			tabToggler.setAttribute('aria-expanded', `${!initialExpanded}`)
		})
	})
})()

;(() => {
	// Remote Mips badge: guard against accidental duplicate mounts
	// (can happen if the PDP customizer script runs more than once).
	const dedupeRemoteMipsBadges = (viewport) => {
		try {
			const imgs = Array.from(viewport.querySelectorAll('img.u1-pdp-customizer__gallery-remote-mips-badge'))
			if (imgs.length <= 1) return
			for (let i = 1; i < imgs.length; i++) {
				try { imgs[i].remove() } catch (_e) {}
			}
		} catch (_e) {}
	}

	const bind = () => {
		const root = document.querySelector('.u1-pdp-customizer')
		if (!root) return false
		const viewport = root.querySelector('.u1-pdp-customizer__gallery-viewport')
		if (!viewport) return false
		if (viewport._u1RemoteMipsBadgeDedupeBound) return true
		viewport._u1RemoteMipsBadgeDedupeBound = true

		dedupeRemoteMipsBadges(viewport)
		try {
			const mo = new MutationObserver(() => dedupeRemoteMipsBadges(viewport))
			mo.observe(viewport, { childList: true, subtree: true })
			// Safety: disconnect after a while (we just need to catch initial/dynamic mounts).
			setTimeout(() => { try { mo.disconnect() } catch (_e) {} }, 12000)
		} catch (_e) {}
		return true
	}

	const init = () => {
		let tries = 0
		const tick = () => {
			tries += 1
			if (bind()) return
			if (tries > 120) return
			try { requestAnimationFrame(tick) } catch (_e) {}
		}
		tick()
	}

	try {
		if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true })
		else init()
	} catch (_e) {}
})()

// U1 PDP Customizer: Rest position modal enhancements (Bottle gallery + OOS lock)
// -----------------------------------------------------------------------------
;(() => {
	const MODAL_SEL = '[data-u1-restpos-modal]'
	const BOTTLE_JSON_SEL = '[data-u1-pdp-restpos-bottle]'

	const clamp = (n, min, max) => Math.min(max, Math.max(min, n))
	const safeJsonParse = (raw, fallback) => {
		try { return JSON.parse(String(raw || '').trim() || fallback) } catch (_e) {
			try { return JSON.parse(fallback) } catch (_e2) { return null }
		}
	}
	const optionNameHandle = (s) =>
		String(s || '')
			.toLowerCase()
			.replace(/&/g, 'and')
			.replace(/[^a-z0-9]+/g, '-')
			.replace(/^-+|-+$/g, '')

	const cache = { productByHandle: new Map() }
	const fetchProduct = async (handle) => {
		const h = String(handle || '').trim()
		if (!h) return null
		if (cache.productByHandle.has(h)) return cache.productByHandle.get(h)
		const p = fetch(`/products/${encodeURIComponent(h)}.js`, { credentials: 'same-origin' })
			.then((r) => (r && r.ok ? r.json() : null))
			.catch(() => null)
		cache.productByHandle.set(h, p)
		return p
	}

	const getCtx = (modal) => {
		try {
			if (!modal) return null
			const root = modal.closest('.u1-pdp-customizer') || document
			const bottleEl = root.querySelector(BOTTLE_JSON_SEL)
			const bottle = bottleEl ? safeJsonParse(bottleEl.textContent, 'null') : null
			if (!bottle || !bottle.variants || !Array.isArray(bottle.variants)) return { root, bottle: null }
			return { root, bottle }
		} catch (_e) {
			return null
		}
	}

	const getBottleColorIndex = (bottle) => {
		try {
			const opts = Array.isArray(bottle && bottle.options) ? bottle.options : []
			const idx = opts.findIndex((n) => optionNameHandle(n) === 'color')
			if (idx >= 0) return idx
			if (opts.length === 1) return 0
		} catch (_e) {}
		return -1
	}
	const bottleVariantColorValue = (bottle, v) => {
		if (!v) return ''
		const idx = getBottleColorIndex(bottle)
		try {
			if (idx === 0 && typeof v.option1 !== 'undefined') return String(v.option1 || '')
			if (idx === 1 && typeof v.option2 !== 'undefined') return String(v.option2 || '')
			if (idx === 2 && typeof v.option3 !== 'undefined') return String(v.option3 || '')
		} catch (_e) {}
		try {
			if (idx >= 0 && Array.isArray(v.options) && typeof v.options[idx] !== 'undefined') return String(v.options[idx] || '')
		} catch (_e2) {}
		try {
			if (idx === 0) {
				const t = String(v.public_title || v.title || '').trim()
				if (!t || t.toLowerCase() === 'default title') return ''
				return t.includes(' / ') ? t.split(' / ')[0].trim() : t
			}
		} catch (_e3) {}
		return ''
	}
	const getVariantIdForColor = (bottle, colorValue) => {
		const wanted = String(colorValue || '').trim()
		const list = Array.isArray(bottle && bottle.variants) ? bottle.variants : []
		if (!wanted) {
			const any = list.find((v) => v && v.available) || list[0] || null
			return any && any.id ? Number(any.id) || 0 : 0
		}
		const exactAvail = list.find((v) => v && v.available && bottleVariantColorValue(bottle, v) === wanted)
		if (exactAvail && exactAvail.id) return Number(exactAvail.id) || 0
		const exact = list.find((v) => v && bottleVariantColorValue(bottle, v) === wanted)
		if (exact && exact.id) return Number(exact.id) || 0
		const any = list.find((v) => v && v.available) || list[0] || null
		return any && any.id ? Number(any.id) || 0 : 0
	}
	const hasAvailableVariantForColor = (bottle, colorValue) => {
		const wantedH = optionNameHandle(String(colorValue || '').trim())
		if (!wantedH) return false
		const list = Array.isArray(bottle && bottle.variants) ? bottle.variants : []
		return list.some((v) => v && v.available === true && optionNameHandle(bottleVariantColorValue(bottle, v)) === wantedH)
	}

	const getSelectedColor = (modal) => {
		try {
			const btn =
				modal.querySelector('.u1-pdp-color__swatch.is-selected') ||
				modal.querySelector('.u1-pdp-color__swatch[aria-pressed="true"]')
			if (btn && btn.dataset && btn.dataset.u1RestposColor) return String(btn.dataset.u1RestposColor || '').trim()
		} catch (_e) {}
		try {
			const el = modal.querySelector('[data-u1-restpos-color-name]')
			const txt = el ? String(el.textContent || '').trim() : ''
			return txt && txt.toLowerCase() !== 'pick your style' ? txt : ''
		} catch (_e2) {}
		return ''
	}

	const disableOosSwatches = (modal, bottle) => {
		try {
			const btns = Array.from(modal.querySelectorAll('[data-u1-restpos-colors] .u1-pdp-color__swatch'))
			btns.forEach((btn) => {
				const c = btn && btn.dataset ? String(btn.dataset.u1RestposColor || btn.dataset.u1PdpValue || '') : ''
				const disabled = !hasAvailableVariantForColor(bottle, c)
				btn.classList.toggle('is-disabled', disabled)
				btn.disabled = disabled
				btn.setAttribute('aria-disabled', disabled ? 'true' : 'false')
			})
		} catch (_e) {}
	}

	const getImagesForVariant = (productJson, variantId) => {
		const vid = Number(variantId || 0) || 0
		if (!productJson || !vid) return []
		try {
			// Best case: product.media items with variant_ids/attached_to_variant_ids
			const media = Array.isArray(productJson.media) ? productJson.media : []
			if (media.length && typeof media[0] === 'object' && media[0] != null) {
				const picked = media.filter((m) => {
					try {
						const t = String(m.media_type || m.mediaType || 'image')
						if (t && t !== 'image') return false
						const ids =
							(Array.isArray(m.variant_ids) ? m.variant_ids : []) ||
							(Array.isArray(m.attached_to_variant_ids) ? m.attached_to_variant_ids : []) ||
							(Array.isArray(m.attachedToVariantIds) ? m.attachedToVariantIds : []) ||
							[]
						return Array.isArray(ids) && ids.map((x) => Number(x || 0)).includes(vid)
					} catch (_e) {
						return false
					}
				})
				const srcs = picked
					.map((m) => String((m && (m.src || (m.preview_image && m.preview_image.src) || (m.previewImage && m.previewImage.src))) || ''))
					.filter(Boolean)
				if (srcs.length) return srcs
			}

			// Next: images as objects with variant_ids
			const imgs = Array.isArray(productJson.images) ? productJson.images : []
			if (imgs.length && typeof imgs[0] === 'object' && imgs[0] != null) {
				const picked = imgs.filter((img) => {
					try {
						const ids = Array.isArray(img && img.variant_ids) ? img.variant_ids : []
						return ids.includes(vid)
					} catch (_e) {
						return false
					}
				})
				const srcs = picked.map((img) => String((img && img.src) || '')).filter(Boolean)
				if (srcs.length) return srcs
			}

			// /products/handle.js common: images is array of strings (cannot map by variant)
			if (imgs.length && typeof imgs[0] === 'string') {
				return imgs.map((s) => String(s || '')).filter(Boolean)
			}
		} catch (_e2) {
			return []
		}
		return []
	}

	const getFilenameKey = (src) => {
		try {
			const u = new URL(String(src || ''), window.location.origin)
			const name = (u.pathname || '').split('/').pop() || ''
			return String(name).toLowerCase()
		} catch (_e) {
			const s = String(src || '').split('?')[0].split('#')[0]
			const name = s.split('/').pop() || ''
			return String(name).toLowerCase()
		}
	}

	// Heurística: si el merchant usa naming tipo "bottle-charcoal-01.jpg",
	// podemos mapear por palabras del colorHandle (ej "charcoal-black").
	const getImagesByColorNameHeuristic = (productJson, colorValue) => {
		try {
			const colorHandle = optionNameHandle(colorValue)
			if (!productJson || !colorHandle) return []

			const imgs = Array.isArray(productJson.images) ? productJson.images : []
			const list = (imgs.length && typeof imgs[0] === 'string') ? imgs.map((s) => String(s || '')).filter(Boolean) : []
			if (!list.length) return []

			const tokens = colorHandle.split('-').map((t) => String(t || '').trim()).filter(Boolean)
			const scored = list
				.map((src) => {
					const key = getFilenameKey(src)
					let score = 0
					if (key.includes(colorHandle)) score += 3
					tokens.forEach((t) => {
						if (t.length < 3) return
						if (key.includes(t)) score += 1
					})
					return { src, score }
				})
				.filter((x) => x.score > 0)

			if (!scored.length) return []
			const maxScore = scored.reduce((m, x) => Math.max(m, x.score), 0)
			// Quedarnos con las "mejores" (evita traer fotos de otros colores por un token genérico)
			return scored.filter((x) => x.score === maxScore).map((x) => x.src)
		} catch (_e) {
			return []
		}
	}

	const renderGallery = (modal, srcs) => {
		const g = modal.querySelector('[data-u1-restpos-gallery]')
		const track = modal.querySelector('[data-u1-restpos-gallery-track]')
		const bPrev = modal.querySelector('[data-u1-restpos-gallery-prev]')
		const bNext = modal.querySelector('[data-u1-restpos-gallery-next]')
		if (!g || !track) return

		// Controller stored on the gallery element so handlers always use the latest slides.
		if (!g._u1Ctrl) {
			g._u1Ctrl = {
				idx: 0,
				slides: [],
				bindOnce: false,
				setBtnStates: () => {},
				scrollToIndex: () => {},
				rebuild: () => {},
			}
		}
		const C = g._u1Ctrl
		C.rebuild = (imgs) => {
			const list = Array.isArray(imgs) ? imgs.filter(Boolean) : []
			const finalImgs = list.length ? list : ['']
			C.idx = 0

			track.innerHTML = finalImgs
				.map((src) => {
					if (!src) {
					return `<figure class="u1-restpos-gallery__slide" data-u1-restpos-slide><div class="u1-pdp-customizer__gallery-placeholder" aria-hidden="true"></div></figure>`
					}
					const safe = String(src).replace(/"/g, '&quot;')
				return `<figure class="u1-restpos-gallery__slide" data-u1-restpos-slide><img class="u1-restpos-gallery__img" loading="eager" decoding="async" alt="" src="${safe}" width="2000" height="2000"></figure>`
				})
				.join('')

			C.slides = Array.from(track.querySelectorAll('[data-u1-restpos-slide]'))
			g.classList.toggle('is-carousel', C.slides.length > 1)

			C.setBtnStates = () => {
				const prevDisabled = C.idx <= 0
				const nextDisabled = C.idx >= C.slides.length - 1
				if (bPrev) {
					bPrev.classList.toggle('is-disabled', prevDisabled)
					bPrev.setAttribute('aria-disabled', prevDisabled ? 'true' : 'false')
				}
				if (bNext) {
					bNext.classList.toggle('is-disabled', nextDisabled)
					bNext.setAttribute('aria-disabled', nextDisabled ? 'true' : 'false')
				}
			}
			C.scrollToIndex = (i, behavior) => {
				C.idx = clamp(Number(i || 0) || 0, 0, Math.max(0, C.slides.length - 1))
				const el = C.slides[C.idx]
				const left = el ? el.offsetLeft : 0
				try { track.scrollTo({ left, behavior: behavior || 'smooth' }) } catch (_e) { track.scrollLeft = left }
				C.setBtnStates()
			}

			C.scrollToIndex(0, 'auto')
		}

		// bind once per modal
		if (!C.bindOnce) {
			C.bindOnce = true
			try {
				if (bPrev) bPrev.addEventListener('click', () => { if (bPrev.getAttribute('aria-disabled') === 'true') return; C.scrollToIndex(C.idx - 1) })
				if (bNext) bNext.addEventListener('click', () => { if (bNext.getAttribute('aria-disabled') === 'true') return; C.scrollToIndex(C.idx + 1) })
				track.addEventListener(
					'scroll',
					() => {
						if (!C.slides.length) return
						const x = Number(track.scrollLeft || 0) || 0
						let best = 0
						let bestDist = Infinity
						for (let i = 0; i < C.slides.length; i++) {
							const d = Math.abs(Number(C.slides[i].offsetLeft || 0) - x)
							if (d < bestDist) {
								bestDist = d
								best = i
							}
						}
						C.idx = clamp(best, 0, Math.max(0, C.slides.length - 1))
						C.setBtnStates()
					},
					{ passive: true }
				)
			} catch (_e2) {}
		}

		C.rebuild(Array.isArray(srcs) ? srcs : [])
	}

	const hydrate = async (modal) => {
		const ctx = getCtx(modal)
		if (!ctx || !ctx.bottle) return

		// Lock OOS colors in modal picker
		disableOosSwatches(modal, ctx.bottle)

		// Gallery by variant via product JSON (variant_ids -> images)
		const handle = String(ctx.bottle.handle || '').trim()
		const productJson = await fetchProduct(handle)
		const color = getSelectedColor(modal)
		const variantId = getVariantIdForColor(ctx.bottle, color)
		let images = getImagesForVariant(productJson, variantId)

		// If we couldn't map by variant_ids, try mapping by filename convention (color words in filename)
		try {
			if (images && images.length && productJson && Array.isArray(productJson.images) && typeof productJson.images[0] === 'string') {
				// When getImagesForVariant returns "all images" (strings), prefer a filtered subset per color if possible.
				const filtered = getImagesByColorNameHeuristic(productJson, color)
				if (filtered && filtered.length) images = filtered
			} else if (!images || !images.length) {
				const filtered = getImagesByColorNameHeuristic(productJson, color)
				if (filtered && filtered.length) images = filtered
			}
		} catch (_eH) {}

		// Fallback: if we can't map images, use the selected variant featured image from the embedded bottle JSON
		try {
			if (!images || !images.length) {
				const vv = Array.isArray(ctx.bottle.variants) ? ctx.bottle.variants.find((v) => v && Number(v.id) === Number(variantId)) : null
				const fi = vv && vv.featured_image ? vv.featured_image : null
				const src =
					fi && (fi.src || fi.url) ? String(fi.src || fi.url) :
					typeof fi === 'string' ? String(fi) :
					''
				if (src) images = [src]
			}
		} catch (_eF) {}

		renderGallery(modal, images)
	}

	// Avoid coupling the modal with the PDP gallery state.
	// IMPORTANT: Do NOT hide the sticky offer on modal open; once visible, it should stay visible.
	const resetPdpGalleryBehindModal = (root) => {
		try {
			if (!root) return
			// Reset gallery behind modal so it doesn't depend on what you were viewing (visor/remote/etc).
			try {
				const mainTrack = root.querySelector('[data-u1-pdp-gallery-track]')
				if (mainTrack) {
					try { mainTrack.scrollTo({ left: 0, behavior: 'auto' }) } catch (_eS) { mainTrack.scrollLeft = 0 }
				}
			} catch (_eR) {}
		} catch (_e) {}
	}

	const watch = () => {
		const modals = Array.from(document.querySelectorAll(MODAL_SEL))
		modals.forEach((modal) => {
			if (modal._u1RestposEnhWatching) return
			modal._u1RestposEnhWatching = true
			let wasOpen = false

			const runIfOpen = () => {
				try {
					const openNow = !modal.hidden && modal.classList.contains('is-open')
					const root = modal.closest('.u1-pdp-customizer') || null

					// Open transition
					if (openNow && !wasOpen) {
						wasOpen = true
						resetPdpGalleryBehindModal(root)
					}

					// Close transition
					if (!openNow && wasOpen) {
						wasOpen = false
					}

					if (!openNow) return
					hydrate(modal)
				} catch (_e) {}
			}

			try {
				const mo = new MutationObserver(() => runIfOpen())
				mo.observe(modal, { attributes: true, attributeFilter: ['class', 'hidden'] })
			} catch (_e2) {}

			// Re-hydrate after color click (section JS re-renders/updates state)
			try {
				modal.addEventListener('click', (e) => {
					const t = e && e.target && e.target.closest ? e.target : null
					if (!t) return
					if (!t.closest('.u1-pdp-color__swatch')) return
					// Esperar a que el section marque el selected + actualice state/label
					requestAnimationFrame(() => requestAnimationFrame(() => hydrate(modal)))
				})
			} catch (_e3) {}

			// También escuchar cambios del label (cubre re-click del mismo color / updates async)
			try {
				const nameEl = modal.querySelector('[data-u1-restpos-color-name]')
				if (nameEl && !nameEl._u1Obs) {
					nameEl._u1Obs = new MutationObserver(() => {
						requestAnimationFrame(() => requestAnimationFrame(() => hydrate(modal)))
					})
					nameEl._u1Obs.observe(nameEl, { childList: true, characterData: true, subtree: true })
				}
			} catch (_e4) {}

			runIfOpen()
		})
	}

	try {
		if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch, { once: true })
		else watch()
	} catch (_e) {}
})()

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
	summary.setAttribute('role', 'button')
	summary.setAttribute('aria-expanded', 'false')

	if (summary.nextElementSibling.getAttribute('id')) {
		summary.setAttribute('aria-controls', summary.nextElementSibling.id)
	}

	summary.addEventListener('click', (event) => {
		event.currentTarget.setAttribute(
			'aria-expanded',
			!event.currentTarget.closest('details').hasAttribute('open'),
		)
	})

	if (summary.closest('header-drawer')) return
	summary.parentElement.addEventListener('keyup', onKeyUpEscape)
})

function onKeyUpEscape(event) {
	if (event.code.toUpperCase() !== 'ESCAPE') return

	const openDetailsElement = event.target.closest('details[open]')
	if (!openDetailsElement) return

	const summaryElement = openDetailsElement.querySelector('summary')
	openDetailsElement.removeAttribute('open')
	summaryElement.setAttribute('aria-expanded', false)
	summaryElement.focus()
}

const trapFocusHandlers = {}

function trapFocus(container, elementToFocus = container) {
	var elements = getFocusableElements(container)
	var first = elements[0]
	var last = elements[elements.length - 1]

	removeTrapFocus()

	trapFocusHandlers.focusin = (event) => {
		if (event.target !== container && event.target !== last && event.target !== first) return

		document.addEventListener('keydown', trapFocusHandlers.keydown)
	}

	trapFocusHandlers.focusout = function () {
		document.removeEventListener('keydown', trapFocusHandlers.keydown)
	}

	trapFocusHandlers.keydown = function (event) {
		if (event.code.toUpperCase() !== 'TAB') return // If not TAB key
		// On the last focusable element and tab forward, focus the first element.
		if (event.target === last && !event.shiftKey) {
			event.preventDefault()
			first.focus()
		}

		//  On the first focusable element and tab backward, focus the last element.
		if ((event.target === container || event.target === first) && event.shiftKey) {
			event.preventDefault()
			last.focus()
		}
	}

	document.addEventListener('focusout', trapFocusHandlers.focusout)
	document.addEventListener('focusin', trapFocusHandlers.focusin)

	elementToFocus.focus()
}

function pauseAllMedia() {
	document.querySelectorAll('.js-youtube').forEach((video) => {
		video.contentWindow.postMessage(
			'{"event":"command","func":"' + 'pauseVideo' + '","args":""}',
			'*',
		)
	})
	document.querySelectorAll('.js-vimeo').forEach((video) => {
		video.contentWindow.postMessage('{"method":"pause"}', '*')
	})
	document.querySelectorAll('video').forEach((video) => video.pause())
	document.querySelectorAll('product-model').forEach((model) => {
		if (model.modelViewerUI) model.modelViewerUI.pause()
	})
}

function removeTrapFocus(elementToFocus = null) {
	document.removeEventListener('focusin', trapFocusHandlers.focusin)
	document.removeEventListener('focusout', trapFocusHandlers.focusout)
	document.removeEventListener('keydown', trapFocusHandlers.keydown)

	if (elementToFocus && !elementToFocus.classList.contains('card-focused')) elementToFocus.focus()
}

class QuantityInput extends HTMLElement {
	constructor() {
		super()
		this.input = this.querySelector('input')
		this.changeEvent = new Event('change', { bubbles: true })

		this.querySelectorAll('button').forEach((button) => {
			this.setMinimumDisable()

			button.addEventListener('click', this.onButtonClick.bind(this))
		})

		var eventList = ['paste', 'input']

		for (event of eventList) {
			this.input.addEventListener(event, function (e) {
				const numberRegex = /^0*?[1-9]\d*$/

				if (numberRegex.test(e.currentTarget.value) || e.currentTarget.value === '') {
					e.currentTarget.value
				} else {
					e.currentTarget.value = 1
				}

				if (e.currentTarget.value === 1 || e.currentTarget.value === '') {
					this.previousElementSibling.classList.add('disabled')
				} else {
					this.previousElementSibling.classList.remove('disabled')
				}
			})
		}

		this.input.addEventListener('focusout', function (e) {
			if (e.currentTarget.value === '') {
				e.currentTarget.value = 1
			}
		})
	}

	setMinimumDisable() {
		if (this.input.value == 1) {
			this.querySelector('button[name="minus"]').classList.add('disabled')
		} else {
			this.querySelector('button[name="minus"]').classList.remove('disabled')
		}
	}

	onButtonClick(event) {
		event.preventDefault()
		const previousValue = this.input.value

		event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown()
		if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent)

		this.setMinimumDisable()
	}
}

customElements.define('quantity-input', QuantityInput)

function debounce(fn, wait) {
	let t
	return (...args) => {
		clearTimeout(t)
		t = setTimeout(() => fn.apply(this, args), wait)
	}
}

const serializeForm = (form) => {
	const obj = {}
	const formData = new FormData(form)
	for (const key of formData.keys()) {
		obj[key] = formData.get(key)
	}
	return JSON.stringify(obj)
}

function fetchConfig(type = 'json') {
	return {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Accept: `application/${type}`,
		},
	}
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
	window.Shopify = {}
}

Shopify.bind = function (fn, scope) {
	return function () {
		return fn.apply(scope, arguments)
	}
}

Shopify.setSelectorByValue = function (selector, value) {
	for (var i = 0, count = selector.options.length; i < count; i++) {
		var option = selector.options[i]
		if (value == option.value || value == option.innerHTML) {
			selector.selectedIndex = i
			return i
		}
	}
}

Shopify.addListener = function (target, eventName, callback) {
	target.addEventListener
		? target.addEventListener(eventName, callback, false)
		: target.attachEvent('on' + eventName, callback)
}

Shopify.postLink = function (path, options) {
	options = options || {}
	var method = options['method'] || 'post'
	var params = options['parameters'] || {}

	var form = document.createElement('form')
	form.setAttribute('method', method)
	form.setAttribute('action', path)

	for (var key in params) {
		var hiddenField = document.createElement('input')
		hiddenField.setAttribute('type', 'hidden')
		hiddenField.setAttribute('name', key)
		hiddenField.setAttribute('value', params[key])
		form.appendChild(hiddenField)
	}
	document.body.appendChild(form)
	form.submit()
	document.body.removeChild(form)
}

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
	this.countryEl = document.getElementById(country_domid)
	this.provinceEl = document.getElementById(province_domid)
	this.provinceContainer = document.getElementById(options['hideElement'] || province_domid)

	Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this))

	this.initCountry()
	this.initProvince()
}

Shopify.CountryProvinceSelector.prototype = {
	initCountry: function () {
		var value = this.countryEl.getAttribute('data-default')
		Shopify.setSelectorByValue(this.countryEl, value)
		this.countryHandler()
	},

	initProvince: function () {
		var value = this.provinceEl.getAttribute('data-default')
		if (value && this.provinceEl.options.length > 0) {
			Shopify.setSelectorByValue(this.provinceEl, value)
		}
	},

	countryHandler: function (e) {
		var opt = this.countryEl.options[this.countryEl.selectedIndex]
		var raw = opt.getAttribute('data-provinces')
		var provinces = JSON.parse(raw)

		this.clearOptions(this.provinceEl)
		if (provinces && provinces.length == 0) {
			this.provinceContainer.style.display = 'none'
		} else {
			for (var i = 0; i < provinces.length; i++) {
				var opt = document.createElement('option')
				opt.value = provinces[i][0]
				opt.innerHTML = provinces[i][1]
				this.provinceEl.appendChild(opt)
			}

			this.provinceContainer.style.display = ''
		}
	},

	clearOptions: function (selector) {
		while (selector.firstChild) {
			selector.removeChild(selector.firstChild)
		}
	},

	setOptions: function (selector, values) {
		for (var i = 0, count = values.length; i < values.length; i++) {
			var opt = document.createElement('option')
			opt.value = values[i]
			opt.innerHTML = values[i]
			selector.appendChild(opt)
		}
	},
}

class MenuDrawer extends HTMLElement {
	constructor() {
		super()

		this.mainDetailsToggle = this.querySelector('details')
		const summaryElements = this.querySelectorAll('summary')
		this.addAccessibilityAttributes(summaryElements)

		if (navigator.platform === 'iPhone')
			document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`)

		this.addEventListener('keyup', this.onKeyUp.bind(this))
		this.addEventListener('focusout', this.onFocusOut.bind(this))
		this.bindEvents()
	}

	bindEvents() {
		this.querySelectorAll('summary').forEach((summary) =>
			summary.addEventListener('click', this.onSummaryClick.bind(this)),
		)
		this.querySelectorAll('button').forEach((button) => {
			if (this.querySelector('.toggle-scheme-button') === button) return
			if (this.querySelector('.header__localization-button') === button) return
			if (this.querySelector('.header__localization-lang-button') === button) return
			button.addEventListener('click', this.onCloseButtonClick.bind(this))
		})
	}

	addAccessibilityAttributes(summaryElements) {
		summaryElements.forEach((element) => {
			element.setAttribute('role', 'button')
			element.setAttribute('aria-expanded', false)
			element.setAttribute('aria-controls', element.nextElementSibling.id)
		})
	}

	onKeyUp(event) {
		if (event.code.toUpperCase() !== 'ESCAPE') return

		const openDetailsElement = event.target.closest('details[open]')
		if (!openDetailsElement) return

		openDetailsElement === this.mainDetailsToggle
			? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary'))
			: this.closeSubmenu(openDetailsElement)
	}

	onSummaryClick(event) {
		const summaryElement = event.currentTarget
		const detailsElement = summaryElement.parentNode
		const isOpen = detailsElement.hasAttribute('open')

		if (detailsElement === this.mainDetailsToggle) {
			if (isOpen) event.preventDefault()
			isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement)
		} else {
			trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'))

			setTimeout(() => {
				detailsElement.classList.add('menu-opening')
			})
		}
	}

	openMenuDrawer(summaryElement) {
		setTimeout(() => {
			this.mainDetailsToggle.classList.add('menu-opening')
		})
		summaryElement.setAttribute('aria-expanded', true)
		trapFocus(this.mainDetailsToggle, summaryElement)
		document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)
	}

	closeMenuDrawer(event, elementToFocus = false) {
		if (event !== undefined) {
			this.mainDetailsToggle.classList.remove('menu-opening')
			this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
				details.removeAttribute('open')
				details.classList.remove('menu-opening')
			})
			this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false)
			document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`)
			removeTrapFocus(elementToFocus)
			this.closeAnimation(this.mainDetailsToggle)
			this.header = this.header || document.querySelector('.shopify-section-header')
			const main = document.querySelector('main')
			if (
				main.querySelectorAll('.shopify-section')[0]?.classList.contains('section--has-overlay') &&
				!this.header.classList.contains('animate')
			) {
				this.header.classList.add('color-background-1', 'color-background-3')
			}
			if (
				this.header.classList.contains('color-background-1') &&
				!this.header.classList.contains('shopify-section-header-sticky')
			) {
				this.header.classList.add('color-background-3')
			}
		}
	}

	onFocusOut(event) {
		setTimeout(() => {
			if (
				this.mainDetailsToggle.hasAttribute('open') &&
				!this.mainDetailsToggle.contains(document.activeElement)
			)
				if (this.classList.contains('mobile-facets__wrapper')) this.closeMenuDrawer()
				else this.closeMenuDrawer(event)
		})
	}

	onCloseButtonClick(event) {
		const detailsElement = event.currentTarget.closest('details')
		this.closeSubmenu(detailsElement)
	}

	closeSubmenu(detailsElement) {
		detailsElement.classList.remove('menu-opening')
		removeTrapFocus()
		this.closeAnimation(detailsElement)
	}

	closeAnimation(detailsElement) {
		let animationStart

		const handleAnimation = (time) => {
			if (animationStart === undefined) {
				animationStart = time
			}

			const elapsedTime = time - animationStart

			if (elapsedTime < 400) {
				window.requestAnimationFrame(handleAnimation)
			} else {
				detailsElement.removeAttribute('open')
				if (detailsElement.closest('details[open]')) {
					trapFocus(
						detailsElement.closest('details[open]'),
						detailsElement.querySelector('summary'),
					)
				}
			}
		}

		window.requestAnimationFrame(handleAnimation)
	}
}

customElements.define('menu-drawer', MenuDrawer)

class HeaderDrawer extends MenuDrawer {
	constructor() {
		super()
	}

	openMenuDrawer(summaryElement) {
		this.header = this.header || document.querySelector('.shopify-section-header')
		this.borderOffset =
			this.borderOffset ||
			this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom')
				? 1
				: 0
		document.documentElement.style.setProperty(
			'--header-bottom-position',
			`${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`,
		)

		if (
			this.header.classList.contains('color-background-3') &&
			!this.header.classList.contains('shopify-section-header-sticky')
		) {
			this.header.classList.remove('color-background-3')
		}

		const main = document.querySelector('main')
		if (main.querySelectorAll('.shopify-section')[0]?.classList.contains('section--has-overlay')) {
			this.header.classList.remove('color-background-3')
		}

		setTimeout(() => {
			this.mainDetailsToggle.classList.add('menu-opening')
		})

		summaryElement.setAttribute('aria-expanded', true)
		trapFocus(this.mainDetailsToggle, summaryElement)
		document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)
	}
}

customElements.define('header-drawer', HeaderDrawer)

class ModalDialog extends HTMLElement {
	constructor() {
		super()
		this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false))
		this.addEventListener('keyup', (event) => {
			if (event.code.toUpperCase() === 'ESCAPE') this.hide()
		})
		if (this.classList.contains('media-modal')) {
			this.addEventListener('pointerup', (event) => {
				if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model'))
					this.hide()
			})
		} else {
			this.addEventListener('click', (event) => {
				if (event.target === this) this.hide()
			})
		}
	}

	connectedCallback() {
		if (this.moved) return
		this.moved = true
		document.body.appendChild(this)
	}

	show(opener) {
		this.openedBy = opener
		const popup = this.querySelector('.template-popup')
		document.body.classList.add('overflow-hidden')
		this.setAttribute('open', '')
		if (popup) popup.loadContent()
		trapFocus(this, this.querySelector('[role="dialog"]'))
		window.pauseAllMedia()
	}

	hide() {
		let isOpen = false

		this.removeAttribute('open')
		removeTrapFocus(this.openedBy)
		window.pauseAllMedia()

		document.querySelectorAll('body > quick-add-modal').forEach((el) => {
			if (el.hasAttribute('open')) {
				isOpen = true
			}
		})

		if (!isOpen) {
			document.body.classList.remove('overflow-hidden')
			document.body.dispatchEvent(new CustomEvent('modalClosed'))
		}

		const images = document.querySelector('.product-media-modal__content')

		if (images) {
			images.classList.remove('zoom')
		}
	}
}

customElements.define('modal-dialog', ModalDialog)

class ModalOpener extends HTMLElement {
	constructor() {
		super()

		const button = this.querySelector('button')

		if (!button) return
		button.addEventListener('click', () => {
			const modal = document.querySelector(this.getAttribute('data-modal'))
			if (modal) modal.show(button)
		})
	}
}

customElements.define('modal-opener', ModalOpener)

class DeferredMedia extends HTMLElement {
	constructor() {
		super()
		this.querySelector('[id^="Deferred-Poster-"]')?.addEventListener(
			'click',
			this.loadContent.bind(this),
		)
	}

	loadContent() {
		if (!this.getAttribute('loaded')) {
			const content = document.createElement('div')
			content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true))

			this.setAttribute('loaded', true)
			window.pauseAllMedia()
			this.appendChild(content.querySelector('video, model-viewer, iframe')).focus()

			if (
				this.closest('.swiper')?.swiper.slides[
					this.closest('.swiper').swiper.activeIndex
				].querySelector('model-viewer')
			) {
				if (
					!this.closest('.swiper')
						.swiper.slides[this.closest('.swiper').swiper.activeIndex].querySelector('model-viewer')
						.classList.contains('shopify-model-viewer-ui__disabled')
				) {
					this.closest('.swiper').swiper.params.noSwiping = true
					this.closest('.swiper').swiper.params.noSwipingClass = 'swiper-slide'
				}
			}
		}
	}
}

customElements.define('deferred-media', DeferredMedia)

class VariantSelects extends HTMLElement {
	constructor() {
		super()
		this.addEventListener('change', this.onVariantChange)
	}

	onVariantChange() {
		this.updateOptions()
		this.updateMasterId()
		this.toggleAddButton(true, '', false)
		this.updatePickupAvailability()
		this.updateVariantStatuses()

		if (!this.currentVariant) {
			this.toggleAddButton(true, '', true)
			this.setUnavailable()
		} else {
			if (!this.closest('floated-form') && this.currentVariant.featured_media) {
				this.updateMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`)
			}
			this.updateURL()
			this.updateVariantInput()
			this.renderProductInfo()
		}
		if (this.currentVariant) {
			document.dispatchEvent(
			  new CustomEvent("variant:change", {
				detail: {
				  variant: this.currentVariant,
				  previousVariant: this.previousVariant || null,
				  formElement: document.querySelector(
					`#product-form-${this.dataset.section}`
				  ),
				  sectionId: this.dataset.section,
				},
			  })
			);
	  
			// Save the previous version
			this.previousVariant = this.currentVariant;
		  }
	}

	updateOptions() {
		// js-radio-colors was added to display Color swatches in the Dropdown type
		// but Color swatches are no longer supported in this type
		//const fieldsets = Array.from(this.querySelectorAll(".js-radio-colors"));

		this.options = Array.from(this.querySelectorAll('select'), (select) => select.value)
		//.concat(
		//	fieldsets.map((fieldset) => {
		//		return Array.from(fieldset.querySelectorAll("input")).find(
		//			(radio) => radio.checked,
		//		).value;
		//	}),
		//);
	}

	updateMasterId() {
		if (this.variantData || this.querySelector('[type="application/json"]')) {
			this.currentVariant = this.getVariantData().find((variant) => {
				//this.options.sort();
				//variant.options.sort();

				return !variant.options
					.map((option, index) => {
						return this.options[index] === option
					})
					.includes(false)
			})
		}
	}

	isHidden(elem) {
		const styles = window.getComputedStyle(elem)
		return styles.display === 'none' || styles.visibility === 'hidden'
	}

	updateMedia(mediaId) {
		if (!this.currentVariant || !this.currentVariant?.featured_media) return

		const currentSection = document.querySelector(`[data-section="main-${this.dataset.section}"]`)

		if (currentSection) {
			this.mediaList = currentSection.querySelector('.product__media-list')
			const activeMedia = this.mediaList.querySelector(`[data-media-id="${mediaId}"]`)
			this.mediaList.querySelectorAll('[data-media-id]').forEach((element) => {
				element.classList.remove('active')
			})
			if (activeMedia) activeMedia.classList.add('active')

			const mediaElements = Array.from(this.mediaList.querySelectorAll('.product__media-item'))
			const index = mediaElements.indexOf(activeMedia) || 0

			if (this.closest('.product__outer').querySelector('.product__media-list')) {
				this.closest('.product__outer').querySelector('.product__media-list').dataset.currentIndex =
					index
			}
		}

		const swiperWrappers = document.querySelectorAll('.product__media-wrapper')

		swiperWrappers.forEach((elem) => {
			if (!this.isHidden(elem)) {
				const newMedia = elem.querySelector(
					`[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`,
				)

				if (elem.querySelector('.js-media-list') && elem.querySelector('.js-media-list').swiper) {
					elem
						.querySelector('.js-media-list')
						.swiper.slideTo(elem.querySelector('.js-media-list').swiper.slides.indexOf(newMedia))
				} else if (
					elem.querySelector('.js-media-list-mobile') &&
					elem.querySelector('.js-media-list-mobile').swiper
				) {
					elem
						.querySelector('.js-media-list-mobile')
						.swiper.slideTo(
							elem.querySelector('.js-media-list-mobile').swiper.slides.indexOf(newMedia),
						)
				}
			}
		})
	}

	updateURL() {
		if (!this.classList.contains('featured-product-radios')) {
			if (!this.currentVariant || this.dataset.updateUrl === 'false') return
			window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`)
		}
	}

	updateVariantInput() {
		const productForms = document.querySelectorAll(
			`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`,
		)
		productForms.forEach((productForm) => {
			const input = productForm.querySelector('input[name="id"]')
			input.value = this.currentVariant.id
			input.dispatchEvent(new Event('change', { bubbles: true }))
		})
	}

	updateVariantStatuses() {
		const selectedOptionOneVariants = this.variantData.filter(
			(variant) => this.querySelector(':checked').value === variant.option1,
		)
		const inputWrappers = [...this.querySelectorAll('.product-form__controls')]
		inputWrappers.forEach((option, index) => {
			if (index === 0) return
			const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
			const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value
			const availableOptionInputsValue = selectedOptionOneVariants
				.filter(
					(variant) => variant.available && variant[`option${index}`] === previousOptionSelected,
				)
				.map((variantOption) => variantOption[`option${index + 1}`])
			this.setInputAvailability(optionInputs, availableOptionInputsValue)
		})
	}

	setInputAvailability(listOfOptions, listOfAvailableOptions) {
		listOfOptions.forEach((input) => {
			if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
				if (input.tagName === 'OPTION') {
					input.innerText = input.getAttribute('value')
				} else if (input.tagName === 'INPUT') {
					input.classList.remove('disabled')
				}
			} else {
				if (input.tagName === 'OPTION') {
					input.innerText = window.variantStrings.unavailable_with_option.replace(
						'[value]',
						input.getAttribute('value'),
					)
				} else if (input.tagName === 'INPUT') {
					input.classList.add('disabled')
				}
			}
		})
	}

	updatePickupAvailability() {
		const pickUpAvailability = document.querySelector('pickup-availability')
		if (!pickUpAvailability) return

		if (this.currentVariant && this.currentVariant.available) {
			pickUpAvailability.fetchAvailability(this.currentVariant.id)
		} else {
			pickUpAvailability.removeAttribute('available')
			pickUpAvailability.innerHTML = ''
		}
	}

	renderProductInfo() {
		const requestedVariantId = this.currentVariant.id
		const sectionId = this.dataset.originalSection
			? this.dataset.originalSection
			: this.dataset.section

		fetch(
			`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${
				this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
			}`,
		)
			.then((response) => response.text())
			.then((responseText) => {
				// prevent unnecessary ui changes from abandoned selections
				if (this.currentVariant?.id !== requestedVariantId) return

				const html = new DOMParser().parseFromString(responseText, 'text/html')
				const destination = document.getElementById(
					`price-${this.dataset.section}`
				)
				const source = html.getElementById(
					`price-${
						this.dataset.originalSection
							? this.dataset.originalSection
							: this.dataset.section
					}`
				)
				const skuSource = html.getElementById(
					`Sku-${
						this.dataset.originalSection
							? this.dataset.originalSection
							: this.dataset.section
					}`
				)
				const skuDestination = document.getElementById(
					`Sku-${this.dataset.section}`
				)
				const inventorySource = html.getElementById(
					`Inventory-${
						this.dataset.originalSection
							? this.dataset.originalSection
							: this.dataset.section
					}`
				)
				const inventoryDestination = document.getElementById(
					`Inventory-${this.dataset.section}`
				)
				const colorNameSources = html.querySelectorAll(
					`[data-color-name-id="ColorName-${
						this.dataset.originalSection
							? this.dataset.originalSection
							: this.dataset.section
					}"]`
				)
				const colorNameDestinations = document.querySelectorAll(
					`[data-color-name-id="ColorName-${
						this.dataset.originalSection && !this.closest('quick-add-modal')
							? this.dataset.originalSection
							: this.dataset.section
					}"]`
				)
				if (colorNameSources?.length === colorNameDestinations?.length) {
					colorNameDestinations.forEach((colorNameDestination, index) => {
						colorNameDestination.innerHTML = colorNameSources[index].innerHTML
					})
				}

				if (source && destination) destination.innerHTML = source.innerHTML
				if (inventorySource && inventoryDestination)
					inventoryDestination.innerHTML = inventorySource.innerHTML
				if (skuSource && skuDestination) {
					skuDestination.innerHTML = skuSource.innerHTML
					skuDestination.classList.toggle(
						'visibility-hidden',
						skuSource.classList.contains('visibility-hidden')
					)
				}

				const price = document.getElementById(`price-${this.dataset.section}`)

				if (price) price.classList.remove('visibility-hidden')

				if (inventoryDestination)
					inventoryDestination.classList.toggle(
						'visibility-hidden',
						inventorySource.innerText === ''
					)

				this.toggleAddButton(
					!this.currentVariant.available,
					window.variantStrings.soldOut
				)

				// product media
				if (this.dataset?.variantMediaDisplay !== 'show_all') {
					const sourceSectionId = this.dataset.originalSection
						? this.dataset.originalSection
						: this.dataset.section
					const currentSectionId = this.dataset.section

					const mediaSource = html.querySelector(
						`[data-section="product-media-${sourceSectionId}"]`
					)
					const mediaDestination = document.querySelector(
						`[data-section="product-media-${currentSectionId}"]`
					)

					if (mediaSource && mediaDestination) {
						mediaDestination.innerHTML = mediaSource.innerHTML

						const parentQuickView = this.closest('quick-view-modal')
						if (parentQuickView) {
							if (typeof parentQuickView.removeDOMElements === 'function') {
								parentQuickView.removeDOMElements(mediaDestination)
							}
							if (typeof parentQuickView.initSlider === 'function') {
								parentQuickView.initSlider()
							}
						} else {
							const section = document.getElementById(
								`shopify-section-${currentSectionId}`
							)

							if (section && typeof initProductPage === 'function') {
								initProductPage(section)
							}
						}
						if (document.querySelector('.js-media-list')) {
							subSliderInit(true)
							sliderInit(true)
						}
					}
				}
			})
	}

	toggleAddButton(disable = true, text, modifyClass = true) {
		const productForm = document.getElementById(`product-form-${this.dataset.section}`)
		if (!productForm) return
		const addButton = productForm.querySelector('[name="add"]')
		const addButtonText = productForm.querySelector('[name="add"] > span')
		if (!addButton) return

		if (disable) {
			addButton.setAttribute('disabled', 'disabled')
			if (text) addButtonText.textContent = text
		} else {
			addButton.removeAttribute('disabled')
			addButtonText.textContent = window.variantStrings.addToCart
		}

		if (!modifyClass) return
	}

	setUnavailable() {
		const button = document.getElementById(`product-form-${this.dataset.section}`)
		const addButton = button.querySelector('[name="add"]')
		const price = document.getElementById(`price-${this.dataset.section}`)
		const inventory = document.getElementById(`Inventory-${this.dataset.section}`)
		const sku = document.getElementById(`Sku-${this.dataset.section}`)

		if (!addButton) return
		this.toggleAddButton(true, window.variantStrings.unavailable)
		if (price) price.classList.add('visibility-hidden')
		if (inventory) inventory.classList.add('visibility-hidden')
		if (sku) sku.classList.add('visibility-hidden')
	}

	getVariantData() {
		this.variantData =
			this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent)
		return this.variantData
	}
}

customElements.define('variant-selects', VariantSelects)

class VariantRadios extends VariantSelects {
	constructor() {
		super()
	}

	setInputAvailability(listOfOptions, listOfAvailableOptions) {
		listOfOptions.forEach((input) => {
			if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
				input.classList.remove('disabled')
			} else {
				input.classList.add('disabled')
			}
		})
	}

	updateOptions() {
		const fieldsets = Array.from(this.querySelectorAll('fieldset'))
		this.options = fieldsets.map((fieldset) => {
			return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value
		})
	}
}

customElements.define('variant-radios', VariantRadios)

class PasswordViewer {
	constructor() {
		const passwordField = document.querySelectorAll('.field--pass')

		passwordField.forEach((el) => {
			const input = el.querySelector('input')
			const btnWrapper = el.querySelector('.button-pass-visibility')
			const btnOpen = el.querySelector('.icon-eye-close')
			const btnClose = el.querySelector('.icon-eye')

			input.addEventListener('input', () => {
				input.value !== ''
					? (btnWrapper.style.display = 'block')
					: (btnWrapper.style.display = 'none')
			})

			btnOpen.addEventListener('click', () => {
				input.type = 'text'
				btnOpen.style.display = 'none'
				btnClose.style.display = 'block'
			})

			btnClose.addEventListener('click', () => {
				input.type = 'password'
				btnOpen.style.display = 'block'
				btnClose.style.display = 'none'
			})
		})
	}
}

class ProductRecommendations extends HTMLElement {
	constructor() {
		super()

		const handleIntersection = (entries, observer) => {
			if (!entries[0].isIntersecting) return
			observer.unobserve(this)

			fetch(this.dataset.url)
				.then((response) => response.text())
				.then((text) => {
					const html = document.createElement('div')
					html.innerHTML = text
					const recommendations = html.querySelector('product-recommendations')
					if (recommendations && recommendations.innerHTML.trim().length) {
						this.innerHTML = recommendations.innerHTML
					}

					/* Color swatches */
					const generateSrcset = (image, widths = []) => {
						const imageUrl = new URL(image['src'])
						return widths
							.filter((width) => width <= image['width'])
							.map((width) => {
								imageUrl.searchParams.set('width', width.toString())
								return `${imageUrl.href} ${width}w`
							})
							.join(', ')
					}

					const createImageElement = (image, classes, sizes, productTitle) => {
						const previewImage = image['preview_image']
						const newImage = new Image(previewImage['width'], previewImage['height'])
						newImage.className = classes
						newImage.alt = image['alt'] || productTitle
						newImage.sizes = sizes
						newImage.src = previewImage['src']
						newImage.srcset = generateSrcset(previewImage, [165, 360, 533, 720, 940, 1066])
						newImage.loading = 'lazy'
						return newImage
					}

					const checkSwatches = () => {
						document.querySelectorAll('.js-color-swatches-wrapper').forEach((wrapper) => {
							wrapper.querySelectorAll('.js-color-swatches input').forEach((input) => {
								input.addEventListener('click', (event) => {
									const primaryImage = wrapper.querySelector('.media--first')
									const secondaryImage = wrapper.querySelector('.media--second')
									const handleProduct = wrapper.dataset.product

									if (event.currentTarget.checked && primaryImage) {
										wrapper
											.querySelector('.js-color-swatches-link')
											.setAttribute('href', event.currentTarget.dataset.variantLink)
										if (wrapper.querySelector('.card__add-to-cart button[name="add"]')) {
											wrapper
												.querySelector('.card__add-to-cart button[name="add"]')
												.setAttribute('aria-disabled', false)
											if (wrapper.querySelector('.card__add-to-cart button[name="add"] > span')) {
												wrapper
													.querySelector('.card__add-to-cart button[name="add"] > span')
													.classList.remove('hidden')
												wrapper
													.querySelector('.card__add-to-cart button[name="add"] .sold-out-message')
													.classList.add('hidden')
											}
											wrapper.querySelector('.card__add-to-cart input[name="id"]').value =
												event.currentTarget.dataset.variantId
										}
										const currentColor = event.currentTarget.value

										jQuery.getJSON(
											window.Shopify.routes.root + `products/${handleProduct}.js`,
											function (product) {
												const variant = product.variants.filter(
													(item) =>
														item.featured_media != null && item.options.includes(currentColor),
												)[0]

												if (variant) {
													const newPrimaryImage = createImageElement(
														variant['featured_media'],
														primaryImage.className,
														primaryImage.sizes,
														product.title,
													)

													if (newPrimaryImage.src !== primaryImage.src) {
														let flag = false
														if (secondaryImage) {
															const secondaryImagePathname = new URL(secondaryImage.src).pathname
															const newPrimaryImagePathname = new URL(newPrimaryImage.src).pathname

															if (secondaryImagePathname == newPrimaryImagePathname) {
																primaryImage.remove()
																secondaryImage.classList.remove('media--second')
																secondaryImage.classList.add('media--first')
																flag = true
															}
														}
														if (flag == false) {
															primaryImage.animate(
																{ opacity: [1, 0] },
																{
																	duration: 200,
																	easing: 'ease-in',
																	fill: 'forwards',
																},
															).finished
															setTimeout(function () {
																primaryImage.replaceWith(newPrimaryImage)
																newPrimaryImage.animate(
																	{ opacity: [0, 1] },
																	{ duration: 200, easing: 'ease-in' },
																)
																if (secondaryImage) {
																	secondaryImage.remove()
																}
															}, 200)
														}
													}
												}
											},
										)
									}
								})
							})
						})
					}

					checkSwatches()

					const calcTop = (section) => {
						const imageWrapper = section.querySelectorAll('.card__inner')
						let top = 0

						if (imageWrapper) {
							top = imageWrapper[0].offsetHeight / 2
						} else {
							top = 50
						}

						return top
					}

					const initSlider = () => {
						document.querySelectorAll('.js-recommendation-swiper').forEach((elem, index) => {
							let mobileLayout = 1
							if (elem.dataset.mobileLayout) {
								mobileLayout = elem.dataset.mobileLayout
							}
							let slider = new Swiper(elem, {
								slidesPerView: mobileLayout,
								slidesPerGroup: 1,
								spaceBetween: 8,
								speed: 1000,
								navigation: {
									nextEl: elem.querySelector(
										'.product-recommendations__slider-nav .swiper-button-next',
									),
									prevEl: elem.querySelector(
										'.product-recommendations__slider-nav .swiper-button-prev',
									),
								},
								breakpoints: {
									576: {
										slidesPerView: 2,
										slidesPerGroup: 2,
									},
									750: {
										slidesPerView: 3,
										slidesPerGroup: 3,
									},
									1200: {
										slidesPerView: 4,
										slidesPerGroup: 4,
									},
								},
							})
						})
					}

					const initSection = () => {
						const section = this

						const sectionResizeObserver = new ResizeObserver((entries) => {
							const [entry] = entries
							let top = calcTop(section)
							if (section.querySelector('.product-recommendations__slider-nav'))
								section.querySelector('.product-recommendations__slider-nav').style.top = top + 'px'
						})

						sectionResizeObserver.observe(section)

						initSlider()
					}

					initSection()
				})
				.catch((e) => {
					console.error(e)
				})
		}

		new IntersectionObserver(handleIntersection.bind(this), {
			rootMargin: '0px 0px 200px 0px',
		}).observe(this)
	}
}

customElements.define('product-recommendations', ProductRecommendations)
;(function () {
	const initHeaderOverlay = () => {
		const main = document.getElementById('MainContent')
		const sections = main.querySelectorAll('.shopify-section')
		if (sections.length > 0) {
			const sectionFirstChild = sections[0].querySelector('.section--has-overlay')
			const headerGroupSections = document.querySelectorAll('.shopify-section-group-header-group')
			const header = document.querySelector('.shopify-section-header')

			if (sectionFirstChild) {
				if (sectionFirstChild.classList.contains('section--has-overlay')) {
					if (headerGroupSections[headerGroupSections.length - 1] === header) {
						sections[0].classList.remove('not-margin')
						header.classList.add('color-background-1', 'color-background-3')
					} else {
						sections[0].classList.add('not-margin')
						header.classList.remove('color-background-1', 'color-background-3')
					}
				} else {
					sections[0].classList.remove('not-margin')
					header.classList.remove('color-background-1', 'color-background-3')
				}
			}
		}
	}

	initHeaderOverlay()

	document.addEventListener('shopify:section:load', function () {
		initHeaderOverlay()
	})

	document.addEventListener('shopify:section:unload', function () {
		initHeaderOverlay()
	})

	document.addEventListener('shopify:section:reorder', function () {
		initHeaderOverlay()
	})
})()

function formatMoney(cents, format = '') {
	if (typeof cents === 'string') {
		cents = cents.replace('.', '')
	}
	cents = parseInt(cents, 10)

	let value = ''
	const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/
	const formatString = format || theme.moneyFormat

	function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
		if (isNaN(number) || number == null) {
			return '0'
		}

		number = (number / 100.0).toFixed(precision)

		const parts = number.split('.')
		const dollarsAmount = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousands}`)

		const centsAmount = precision > 0 ? decimal + parts[1] : ''

		return dollarsAmount + centsAmount
	}

	const match = formatString.match(placeholderRegex)
	const formatType = match ? match[1] : 'amount'

	switch (formatType) {
		case 'amount':
			value = formatWithDelimiters(cents, 2, ',', '.')
			break
		case 'amount_no_decimals':
			value = formatWithDelimiters(cents, 0, ',', '.')
			break
		case 'amount_with_comma_separator':
			value = formatWithDelimiters(cents, 2, '.', ',')
			break
		case 'amount_no_decimals_with_comma_separator':
			value = formatWithDelimiters(cents, 0, '.', ',')
			break
		case 'amount_with_apostrophe_separator':
			value = formatWithDelimiters(cents, 2, "'", '.')
			break
		case 'amount_no_decimals_with_space_separator':
			value = formatWithDelimiters(cents, 0, ' ', '.')
			break
		case 'amount_with_space_separator':
			value = formatWithDelimiters(cents, 2, ' ', ',')
			break
		case 'amount_with_period_and_space_separator':
			value = formatWithDelimiters(cents, 2, ' ', '.')
			break
		default:
			value = formatWithDelimiters(cents, 2, ',', '.')
	}

	return formatString.replace(placeholderRegex, value)
}

// CART REFRESH EVENT
// -----------------------------------------------------------------------------

document.documentElement.addEventListener("cart:refresh", () => {
	const sectionsToUpdate = [
	  { id: "cart-count-bubble", selector: "#cart-icon-bubble" },
	  { id: "cart-drawer", selector: "#CartDrawer" },
	  { id: "main-cart-items", selector: ".cart-items-wrapper" },
	  { id: "main-cart-footer", selector: ".cart__footer" },
	  { id: "main-cart-shipping", selector: ".cart-shipping" },
	];
  
	sectionsToUpdate.forEach((section) => {
	  fetch(`${routes.cart_url}?section_id=${section.id}`, {
		method: 'GET',
		credentials: 'same-origin',
		cache: 'no-store',
		headers: { 'X-Requested-With': 'XMLHttpRequest' },
	  })
		.then((response) => response.text())
		.then((html) => {
		  const parsedHTML = new DOMParser().parseFromString(html, "text/html");
		  const sourceSection = parsedHTML.querySelector(section.selector);
		  const destinationSection = document.querySelector(section.selector);
		  if (sourceSection && destinationSection) {
			destinationSection.innerHTML = sourceSection.innerHTML;
		  }
		})
		.catch((e) => console.error(`Error updating ${section.id}:`, e));
	});
  });
  
  // CART REFRESH EVENT END
  // -----------------------------------------------------------------------------

  // PDP Customizer add-to-cart: ensure drawer re-renders with discounts
  // (product-form adds `sections` to /cart/add and calls cart.renderContents,
  // but pdp-customizer uses /cart/add.js without sections; we refresh sections here.)
  document.addEventListener('variant:add', (e) => {
	try {
	  const d = e && e.detail ? e.detail : null;
	  if (!d) return;
	  // product-form includes sectionId/formElement; pdp-customizer does not.
	  if (d.sectionId || d.formElement) return;
	  // PDP customizer persists its picked code in localStorage.
	  // Apply it via the classic `/discount/<code>` hit (no navigation) then refresh sections.
	  const getCode = () => {
		try {
		  return (window.localStorage.getItem('u1_pdp_discount_code') || '').toString().trim();
		} catch (_e) { return ''; }
	  };
	  const code = getCode();
	  const refresh = (delayMs) => setTimeout(() => {
		try { document.documentElement.dispatchEvent(new Event('cart:refresh')); } catch (_e0) {}
	  }, delayMs);
	  if (!code) {
		refresh(250);
		refresh(900);
		return;
	  }
	  const url = `/discount/${encodeURIComponent(code)}?redirect=/cart`;
	  const cartJsonUrl = (window.routes && window.routes.cart_url ? `${window.routes.cart_url}.js` : '/cart.js');

	  const getCartHasDiscount = async () => {
		try {
		  const res = await fetch(cartJsonUrl, { method: 'GET', credentials: 'same-origin', cache: 'no-store', headers: { 'X-Requested-With': 'XMLHttpRequest' } });
		  if (!res.ok) return null;
		  const data = await res.json();
		  const total = Number(data && data.total_price) || 0;
		  const orig = Number(data && data.original_total_price) || 0;
		  if (orig > total) return true;
		  // Some discounts don't change original_total_price; also check discount applications.
		  const apps = Array.isArray(data && data.discount_applications) ? data.discount_applications : [];
		  if (apps.length) return true;
		  return false;
		} catch (_e) { return null; }
	  };

	  const applyViaIframe = () => {
		try {
		  // Hidden iframe navigation to /discount/<code> is the most reliable way to set the cookie.
		  const id = 'u1-discount-apply-frame';
		  let f = document.getElementById(id);
		  if (!f) {
			f = document.createElement('iframe');
			f.id = id;
			f.tabIndex = -1;
			f.setAttribute('aria-hidden', 'true');
			f.style.position = 'absolute';
			f.style.width = '1px';
			f.style.height = '1px';
			f.style.opacity = '0';
			f.style.pointerEvents = 'none';
			f.style.left = '-9999px';
			f.style.top = '0';
			document.body.appendChild(f);
		  }
		  let done = false;
		  const finish = () => {
			if (done) return;
			done = true;
			refresh(120);
			refresh(650);
			refresh(1400);
		  };
		  try { f.onload = () => finish(); } catch (_e0) {}
		  f.src = url;
		  setTimeout(finish, 1800);
		} catch (_e) {
		  refresh(250);
		  refresh(900);
		}
	  };

	  // 1) Try fetch (fast path)
	  try {
		fetch(url, { method: 'GET', credentials: 'include', cache: 'no-store' }).catch(() => {});
	  } catch (_e2) {}
	  // 2) Verify via /cart.js; if not applied, fallback to iframe
	  setTimeout(() => {
		getCartHasDiscount().then((has) => {
		  if (has === true) {
			refresh(120);
			refresh(650);
			return;
		  }
		  applyViaIframe();
		});
	  }, 700);
	} catch (_e) {}
  }, { passive: true });

  // Ensure discount codes apply when the cart drawer uses a submit button (not an <a> link).
  // We mirror the classic Shopify flow: navigate to /discount/<code>?redirect=/checkout.
  ;(() => {
	const getCode = () => {
	  try { return (window.localStorage.getItem('u1_pdp_discount_code') || '').toString().trim(); }
	  catch (_e) { return ''; }
	};
	const shouldHandle = () => {
	  try { return !String(location.pathname || '').includes('/discount/'); } catch (_e) { return true; }
	};
	const go = (code) => {
	  if (!code) return false;
	  const next = `/discount/${encodeURIComponent(code)}?redirect=/checkout`;
	  try { window.location.assign(next); return true; } catch (_e) { return false; }
	};
	const onClick = (e) => {
	  try {
		if (!shouldHandle()) return;
		const t = e && e.target && e.target.closest ? e.target : null;
		if (!t) return;
		const btn = t.closest('#CartDrawer-Checkout, button[name="checkout"], [name="checkout"]');
		if (!btn) return;
		// Limit to cart drawer + cart forms
		const inCart = !!(btn.closest('cart-drawer') || btn.closest('#CartDrawer') || btn.closest('form[action="/cart"]') || btn.closest('form#cart'));
		if (!inCart) return;
		const code = getCode();
		if (!code) return;
		e.preventDefault();
		e.stopPropagation();
		go(code);
	  } catch (_e) {}
	};
	document.addEventListener('click', onClick, true);
	// Safety: also intercept submit from cart forms.
	document.addEventListener('submit', (e) => {
	  try {
		if (!shouldHandle()) return;
		const form = e && e.target ? e.target : null;
		if (!form || !form.matches) return;
		if (!form.matches('#CartDrawer-Form, form[action="/cart"], form#cart')) return;
		const code = getCode();
		if (!code) return;
		// Only for checkout submissions
		const submitter = e.submitter || document.activeElement;
		const isCheckout = !!(submitter && submitter.getAttribute && String(submitter.getAttribute('name') || '') === 'checkout');
		if (!isCheckout) return;
		e.preventDefault();
		e.stopPropagation();
		go(code);
	  } catch (_e) {}
	}, true);
  })();

// U1 PDP Customizer: smooth drag inertia (gallery)
// -----------------------------------------------------------------------------
;(() => {
	const clamp = (n, min, max) => Math.min(max, Math.max(min, n))
	const has = (el, cls) => !!(el && el.classList && el.classList.contains(cls))
	const slideCache = new WeakMap()
	const getSlides = (track) => {
		if (!track) return { slides: [], lefts: [], w: 0 }
		const w = Number(track.clientWidth || 0) || 0
		const cached = slideCache.get(track)
		// Rebuild si cambia ancho o cantidad (resize / cambio de gallery)
		if (cached && cached.w === w && cached.count === cached.slides.length && cached.count > 0) return cached
		const slides = Array.from(track.querySelectorAll('[data-u1-pdp-slide]'))
		const lefts = slides.map((s) => Number(s.offsetLeft || 0) || 0)
		const next = { slides, lefts, w, count: slides.length }
		slideCache.set(track, next)
		return next
	}
	const getLifestyleForSlide = (root, slideEl) => {
		try {
			if (slideEl && slideEl.getAttribute) {
				const a = String(slideEl.getAttribute('data-u1-lifestyle') || '')
				if (a === '1') return true
				if (a === '0') return false
			}
		} catch (_e) {}
		// Fallback: galleries server-rendered sin data-u1-lifestyle
		try {
			const def = root ? String(root.getAttribute('data-u1-pdp-default-gallery-lifestyle') || '1') : '1'
			return def === '1'
		} catch (_e2) {}
		return true
	}
	const applyUiMode = (track) => {
		try {
			if (!track) return
			const root = track._u1UiRoot
			if (!root) return
			const { slides, lefts } = getSlides(track)
			if (!slides.length) return
			const x = Number(track.scrollLeft || 0) || 0
			let best = 0
			let bestDist = Infinity
			for (let i = 0; i < slides.length; i++) {
				const d = Math.abs((lefts[i] || 0) - x)
				if (d < bestDist) { bestDist = d; best = i }
			}
			const isLifestyle = getLifestyleForSlide(root, slides[best])
			const mode = isLifestyle ? 'light' : 'dark'
			if (track._u1UiMode === mode) return
			track._u1UiMode = mode
			root.setAttribute('data-u1-gallery-ui', mode)
		} catch (_e) {}
	}
	const scheduleUiMode = (track) => {
		if (!track) return
		if (track._u1UiRaf) return
		track._u1UiRaf = requestAnimationFrame(() => {
			track._u1UiRaf = 0
			applyUiMode(track)
		})
	}
	const ensureUiMode = (root, track) => {
		if (!root || !track) return
		if (track._u1UiBound) return
		track._u1UiBound = true
		track._u1UiRoot = root
		try {
			track.addEventListener('scroll', () => scheduleUiMode(track), { passive: true })
		} catch (_e) {}
		scheduleUiMode(track)
	}
	try {
		window.addEventListener('resize', () => {
			// WeakMap se invalida solo por reemplazo: forzamos rebuild por cambio de w en getSlides
		})
	} catch (_e) {}

	const getCtx = (target) => {
		const t = target && target.closest ? target : null
		if (!t) return null
		const viewport = t.closest('.u1-pdp-customizer__gallery-viewport')
		if (!viewport) return null
		const root = viewport.closest('.u1-pdp-customizer')
		if (!root) return null
		const ux = String(root.getAttribute('data-u1-gallery-ux-mode') || 'normal')
		if (ux !== 'normal') return null
		const gallery = root.querySelector('[data-u1-pdp-gallery]')
		if (!gallery || !has(gallery, 'is-carousel')) return null
		const track = root.querySelector('[data-u1-pdp-gallery-track]')
		if (!track) return null
		ensureUiMode(root, track)
		return { root, viewport, track }
	}

	const getCtxFromRoot = (target) => {
		const t = target && target.closest ? target : null
		if (!t) return null
		const root = t.closest('.u1-pdp-customizer')
		if (!root) return null
		const ux = String(root.getAttribute('data-u1-gallery-ux-mode') || 'normal')
		if (ux !== 'normal') return null
		const gallery = root.querySelector('[data-u1-pdp-gallery]')
		if (!gallery || !has(gallery, 'is-carousel')) return null
		const viewport = root.querySelector('.u1-pdp-customizer__gallery-viewport')
		const track = root.querySelector('[data-u1-pdp-gallery-track]')
		if (!viewport || !track) return null
		ensureUiMode(root, track)
		return { root, viewport, track }
	}

	const S = {
		active: false,
		pid: null,
		ctx: null,
		startX: 0,
		startY: 0,
		startScroll: 0,
		startIdx: 0,
		startLeft: 0,
		prevLeft: 0,
		nextLeft: 0,
		prevSpan: 1,
		nextSpan: 1,
		lastX: 0,
		lastT: 0,
		velocity: 0, // px/ms (scrollLeft direction)
		locked: null, // null | 'x' | 'y'
		moved: false,
		snapType: '',
		raf: 0,
	}
	const DOT = { el: null, pid: null, x: 0, y: 0 }

	// Mantener dots determinísticos (no depender del state del section)
	const updateDots = (root, activeIdx) => {
		try {
			if (!root) return
			const idx = Number(activeIdx || 0) || 0
			const pager = root.querySelector('[data-u1-pdp-gallery-pager]') || root.querySelector('.u1-pdp-customizer__gallery-pager')
			const scope = pager || root
			const btns = Array.from(scope.querySelectorAll('button[data-u1-idx]'))
			if (!btns.length) return
			btns.forEach((b) => {
				try {
					const bi = Number(b.getAttribute('data-u1-idx') || 0) || 0
					b.setAttribute('aria-current', (bi === idx) ? 'true' : 'false')
				} catch (_e1) {}
			})
		} catch (_e0) {}
	}

	const stopInertia = () => {
		if (S.raf) {
			cancelAnimationFrame(S.raf)
			S.raf = 0
		}
	}

	// Resetear cualquier transform residual de versiones previas (evita “intermitencias”)
	const clearTransforms = (ctx) => {
		try {
			if (!ctx || !ctx.track) return
			const { slides } = getSlides(ctx.track)
			slides.forEach((s) => {
				try {
					s.style.transform = ''
					s.style.zIndex = ''
					s.style.willChange = ''
				} catch (_e) {}
			})
			ctx._u1OLast = null
			ctx._u1OverlayActive = false
		} catch (_e2) {}
	}

	const snapToNearest = (ctx) => {
		if (!ctx || !ctx.root || !ctx.track) return
		const { slides, lefts } = getSlides(ctx.track)
		if (!slides.length) return
		const x = ctx.track.scrollLeft || 0
		let best = 0
		let bestDist = Infinity
		for (let i = 0; i < slides.length; i++) {
			const d = Math.abs((lefts[i] || 0) - x)
			if (d < bestDist) {
				bestDist = d
				best = i
			}
		}
		try { updateDots(ctx.root, best) } catch (_e0) {}
		settleToIndex(ctx, best)
	}

	// Ease-out estable (sin “trabas”)
	const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3)
	const animateTo = (ctx, targetLeft, { durationMs } = { durationMs: 360 }) => {
		if (!ctx || !ctx.track) return
		stopInertia()
		try { clearTransforms(ctx) } catch (_e0) {}
		const track = ctx.track
		const from = track.scrollLeft || 0
		const to = Number(targetLeft || 0) || 0
		const dur = clamp(Number(durationMs || 360) || 360, 160, 520)
		const t0 = performance.now()
		const maxScroll = Math.max(0, (track.scrollWidth || 0) - (track.clientWidth || 0))
		const step = (t) => {
			const p = clamp((t - t0) / dur, 0, 1)
			const eased = easeOutCubic(p)
			const next = from + (to - from) * eased
			track.scrollLeft = clamp(next, 0, maxScroll)
			if (p >= 1) {
				S.raf = 0
				// Restaurar snap cuando ya terminó la animación (evita snap instantáneo al soltar)
				try {
					if (ctx._u1SnapRestore != null) track.style.scrollSnapType = String(ctx._u1SnapRestore || '')
				} catch (_e) {}
				try { applyUiMode(track) } catch (_e1) {}
				// Asegurar aria-current correcto al finalizar animación
				try {
					const { slides, lefts } = getSlides(track)
					if (slides.length) {
						const x = Number(track.scrollLeft || 0) || 0
						let best = 0
						let bestDist = Infinity
						for (let i = 0; i < slides.length; i++) {
							const d = Math.abs((lefts[i] || 0) - x)
							if (d < bestDist) { bestDist = d; best = i }
						}
						updateDots(ctx.root, best)
					}
				} catch (_eD) {}
				try { clearTransforms(ctx) } catch (_e2) {}
				return
			}
			S.raf = requestAnimationFrame(step)
		}
		S.raf = requestAnimationFrame(step)
	}

	// Settle "tipo flecha": same smooth remainder animation after release
	const settleToIndex = (ctx, idx, { durationMs } = { durationMs: 420 }) => {
		if (!ctx || !ctx.root || !ctx.track) return
		const { slides, lefts } = getSlides(ctx.track)
		if (!slides.length) return
		const i = clamp(Number(idx || 0) || 0, 0, slides.length - 1)
		try { updateDots(ctx.root, i) } catch (_e0) {}
		const left = Number(lefts[i] || 0) || 0
		const track = ctx.track

		// Mantener snap desactivado para evitar salto instantáneo
		try { track.style.scrollSnapType = 'none' } catch (_e) {}

		// Usamos animación RAF para poder aplicar el "overlay motion" durante toda la transición.
		animateTo(ctx, left, { durationMs })

		// Restaurar snap luego de la animación (redundante; animateTo ya lo hace)
		window.setTimeout(() => {
			try {
				if (ctx._u1SnapRestore != null) track.style.scrollSnapType = String(ctx._u1SnapRestore || '')
			} catch (_e) {}
		}, clamp(Number(durationMs || 420) || 420, 240, 640))
	}

	const startInertia = (ctx, v0) => {
		if (!ctx || !ctx.track) return
		stopInertia()
		try { clearTransforms(ctx) } catch (_e0) {}

		const track = ctx.track
		const maxScroll = Math.max(0, (track.scrollWidth || 0) - (track.clientWidth || 0))
		let v = Number(v0 || 0) || 0
		// Clamp: evita “disparos” por dt raro
		v = clamp(v, -2.4, 2.4)
		if (Math.abs(v) < 0.02) {
			snapToNearest(ctx)
			return
		}
		let last = performance.now()
		const step = (t) => {
			const dt = Math.max(8, Math.min(34, t - last))
			last = t
			const next = (track.scrollLeft || 0) + v * dt
			const clamped = clamp(next, 0, maxScroll)
			track.scrollLeft = clamped

			// Fricción exponencial (suave)
			const decay = Math.exp(-0.0042 * dt)
			v *= decay

			// Si pegamos contra los bordes, frenamos más rápido
			if (clamped <= 0 || clamped >= maxScroll) v *= 0.6

			if (Math.abs(v) < 0.02) {
				S.raf = 0
				snapToNearest(ctx)
				return
			}
			S.raf = requestAnimationFrame(step)
		}
		S.raf = requestAnimationFrame(step)
	}

	const endDrag = ({ snap } = { snap: true }) => {
		if (!S.active) return
		const ctx = S.ctx
		const pid = S.pid
		S.active = false
		S.ctx = null
		S.locked = null
		// Limpiar estado de drag estable en el ctx
		try {
			if (ctx) {
				ctx._u1DragActive = false
				ctx._u1Drag = null
			}
		} catch (_e) {}

		try {
			if (ctx && ctx.viewport && ctx.viewport.releasePointerCapture && pid != null) {
				ctx.viewport.releasePointerCapture(pid)
			}
		} catch (_e) {}
		S.pid = null

		// NOTA: no restauramos scroll-snap acá. Si lo hacemos, el browser puede "snapear" instantáneo.
		// Se restaura al final de animateTo().

		if (snap && ctx) snapToNearest(ctx)
	}

	document.addEventListener(
		'pointerdown',
		(e) => {
			// Solo botón primario (mouse). Touch no tiene e.button.
			if (typeof e.button === 'number' && e.button !== 0) return

			// No iniciar drag sobre controles interactivos dentro del viewport (ej: dots/pager)
			// Si lo hacemos, el preventDefault/stopPropagation mata el click y los dots no funcionan.
			try {
				const t = e && e.target && e.target.closest ? e.target : null
				if (t) {
					const dot = t.closest('button[data-u1-idx]')
					if (dot) {
						DOT.el = dot
						DOT.pid = e.pointerId
						DOT.x = e.clientX
						DOT.y = e.clientY
						// Evitar que el drag legacy (del section) capture el puntero y genere saltos/cursor
						try { e.stopPropagation() } catch (_eS) {}
						return
					}
					if (t.closest('.u1-pdp-customizer__gallery-pager')) return
					if (t.closest('button, a, input, select, textarea, label')) return
				}
			} catch (_e0) {}
			const ctx = getCtx(e.target)
			if (!ctx) return

			// Evitar selección/highlight de imágenes en desktop (sin romper scroll vertical en mobile)
			try { if (e.pointerType === 'mouse') e.preventDefault() } catch (_e) {}

			stopInertia()
			S.active = true
			S.pid = e.pointerId
			S.ctx = ctx
			S.startX = e.clientX
			S.startY = e.clientY
			S.startScroll = ctx.track.scrollLeft || 0
			try { clearTransforms(ctx) } catch (_eC) {}
			// Guardar "slide de inicio" para que un gesto nunca avance/retroceda 2 slides.
			try {
				const { slides, lefts } = getSlides(ctx.track)
				const x = Number(S.startScroll || 0) || 0
				let best = 0
				let bestDist = Infinity
				for (let i = 0; i < slides.length; i++) {
					const d = Math.abs((lefts[i] || 0) - x)
					if (d < bestDist) { bestDist = d; best = i }
				}
				const startLeft = Number(lefts[best] || 0) || 0
				const prevLeft = Number(lefts[best - 1] || startLeft) || startLeft
				const nextLeft = Number(lefts[best + 1] || startLeft) || startLeft
				S.startIdx = best
				S.startLeft = startLeft
				S.prevLeft = prevLeft
				S.nextLeft = nextLeft
				S.prevSpan = Math.max(1, startLeft - prevLeft || 1)
				S.nextSpan = Math.max(1, nextLeft - startLeft || 1)
				// Guardar en ctx para overlay estable
				ctx._u1DragActive = true
				ctx._u1Drag = {
					startIdx: best,
					startLeft,
					prevLeft,
					nextLeft,
					prevSpan: Math.max(1, startLeft - prevLeft || 1),
					nextSpan: Math.max(1, nextLeft - startLeft || 1),
				}
			} catch (_e) {
				S.startIdx = 0
				S.startLeft = 0
				S.prevLeft = 0
				S.nextLeft = 0
				S.prevSpan = 1
				S.nextSpan = 1
				try { ctx._u1DragActive = true; ctx._u1Drag = null } catch (_e2) {}
			}
			S.lastX = e.clientX
			S.lastT = performance.now()
			S.velocity = 0
			S.locked = null
			S.moved = false

			// Evitar snap mientras se arrastra
			try {
				S.snapType = ctx.track.style.scrollSnapType || ''
				ctx._u1SnapRestore = S.snapType
				ctx.track.style.scrollSnapType = 'none'
			} catch (_e) {}

			// Evitar "native image drag" (extra safety)
			try {
				ctx.viewport.querySelectorAll('img').forEach((img) => {
					try {
						img.draggable = false
						img.addEventListener('dragstart', (ev) => ev.preventDefault(), { passive: false })
					} catch (_e) {}
				})
			} catch (_e) {}

			try {
				if (ctx.viewport && ctx.viewport.setPointerCapture) ctx.viewport.setPointerCapture(S.pid)
			} catch (_e) {}

			// IMPORTANTE: frenamos el drag viejo del section (listeners en target)
			try {
				e.stopPropagation()
			} catch (_e) {}
		},
		{ capture: true, passive: false }
	)

	document.addEventListener(
		'pointermove',
		(e) => {
			if (!S.active || e.pointerId !== S.pid || !S.ctx) return
			const ctx = S.ctx
			const dx = e.clientX - S.startX
			const dy = e.clientY - S.startY

			// Lock intención (para no romper scroll vertical)
			if (S.locked == null) {
				const ax = Math.abs(dx)
				const ay = Math.abs(dy)
				if (ax < 4 && ay < 4) return
				S.locked = ax >= ay ? 'x' : 'y'
			}

			if (S.locked === 'y') {
				// Dejar scroll vertical; soltamos sin snap
				endDrag({ snap: false })
				return
			}

			// Horizontal: mover track + velocity
			try {
				e.preventDefault()
				e.stopPropagation()
			} catch (_e) {}

			const now = performance.now()
			const dt = Math.max(8, now - S.lastT)
			const moveDX = e.clientX - S.lastX
			const deltaX = -moveDX
			// deltaX > 0 cuando el mouse va a la izquierda => scrollLeft debe subir
			S.velocity = clamp(deltaX / dt, -2.4, 2.4)
			// Dirección visual: fijarla por el movimiento del puntero (evita flips cuando scroll queda clamped)
			try {
				if (Math.abs(moveDX) > 0.5) ctx._u1Dir = moveDX < 0 ? 1 : -1
			} catch (_e) {}
			S.lastX = e.clientX
			S.lastT = now

			if (!S.moved && Math.abs(dx) > 6) S.moved = true

			// Target ideal (1:1 con el puntero), con clamp a +/- 1 slide.
			const target = S.startScroll - dx
			const minLeft = Math.min(Number(S.prevLeft || 0) || 0, Number(S.startLeft || 0) || 0, Number(S.nextLeft || 0) || 0)
			const maxLeft = Math.max(Number(S.prevLeft || 0) || 0, Number(S.startLeft || 0) || 0, Number(S.nextLeft || 0) || 0)
			ctx.track.scrollLeft = clamp(target, minLeft, maxLeft)
			try { scheduleUiMode(ctx.track) } catch (_e) {}
		},
		{ capture: true, passive: false }
	)

	document.addEventListener(
		'pointerup',
		(e) => {
			if (!S.active || e.pointerId !== S.pid || !S.ctx) return
			const ctx = S.ctx
			const moved = !!S.moved && S.locked === 'x'
			const v = S.velocity
			// Si hubo drag horizontal: completamos la transición con el mismo "smooth" que la flecha.
			// (Si soltás en el medio, se termina de mover frente a tus ojos; sin salto instantáneo)
			try {
				if (moved) {
					e.preventDefault()
					e.stopPropagation()
				}
			} catch (_e) {}

			endDrag({ snap: false })

			if (!moved) {
				snapToNearest(ctx)
				return
			}

			// Destino: como máximo +/- 1 desde la slide inicial (operación "perfecta")
			const { slides, lefts } = getSlides(ctx.track)
			if (!slides.length) return

			const vel = Number(v || 0) || 0
			const absVel = Math.abs(vel)
			const dx = e.clientX - S.startX
			const dragDir = dx < 0 ? 1 : -1 // dx<0 (arrastras a la izq) => next
			const velDir = vel > 0 ? 1 : -1 // vel>0 => scrollLeft increases => next
			const intentDir = absVel > 0.55 ? velDir : dragDir

			const current = Number(ctx.track.scrollLeft || 0) || 0
			const startLeft = Number(S.startLeft || 0) || 0
			const startIdx = clamp(Number(S.startIdx || 0) || 0, 0, slides.length - 1)
			const hasPrev = startIdx > 0
			const hasNext = startIdx < slides.length - 1

			const progNext = (current - startLeft) / Math.max(1, Number(S.nextSpan || 1) || 1)
			const progPrev = (startLeft - current) / Math.max(1, Number(S.prevSpan || 1) || 1)
			const prog = clamp(intentDir >= 0 ? progNext : progPrev, 0, 1)

			const passed = prog > 0.22
			const flick = absVel > 0.7

			let step = 0
			if ((passed || flick) && intentDir >= 0 && hasNext) step = 1
			if ((passed || flick) && intentDir < 0 && hasPrev) step = -1

			const targetIdx = clamp(startIdx + step, 0, slides.length - 1)
			const targetLeft = Number(lefts[targetIdx] || startLeft) || startLeft
			const span = Math.max(1, step >= 0 ? Number(S.nextSpan || 1) || 1 : Number(S.prevSpan || 1) || 1)
			const rem = Math.abs(targetLeft - current)
			const durationMs = clamp(220 + (rem / span) * 220, 220, 460)

			try { ctx._u1Dir = step !== 0 ? step : intentDir } catch (_e) {}
			settleToIndex(ctx, targetIdx, { durationMs })
		},
		{ capture: true, passive: true }
	)

	document.addEventListener(
		'pointercancel',
		(e) => {
			if (!S.active || e.pointerId !== S.pid) return
			endDrag({ snap: true })
		},
		{ capture: true, passive: true }
	)

	// Flechas: usar la MISMA transición RAF (con overlay motion) que el drag settle
	document.addEventListener('click', (e) => {
		const t = e && e.target ? e.target : null
		if (!t || !t.closest) return
		const btnNext = t.closest('[data-u1-pdp-gallery-next]')
		const btnPrev = t.closest('[data-u1-pdp-gallery-prev]')
		if (!btnNext && !btnPrev) return
		const ctx = getCtxFromRoot(t)
		if (!ctx) return
		const { slides, lefts } = getSlides(ctx.track)
		if (!slides.length) return
		const scroll = Number(ctx.track.scrollLeft || 0) || 0
		let best = 0
		let bestDist = Infinity
		for (let i = 0; i < slides.length; i++) {
			const d = Math.abs((lefts[i] || 0) - scroll)
			if (d < bestDist) { bestDist = d; best = i }
		}
		const delta = btnNext ? 1 : -1
		const nextIdx = clamp(best + delta, 0, slides.length - 1)
		try { ctx._u1Dir = delta } catch (_e) {}
		try { stopInertia() } catch (_e) {}
		settleToIndex(ctx, nextIdx, { durationMs: 420 })
		e.preventDefault()
		e.stopPropagation()
	}, true)

	// Bullets/pager (desktop y mobile): misma transición smooth (sin saltos)
	const goToDot = (dot, e) => {
		try {
			if (!dot) return false
			const idx = Number(dot.getAttribute('data-u1-idx') || 0) || 0
			const ctx = getCtxFromRoot(dot)
			if (!ctx) return false
			const { slides, lefts } = getSlides(ctx.track)
			if (!slides.length) return false
			const i = clamp(idx, 0, slides.length - 1)
			const left = Number(lefts[i] || 0) || 0
			const from = Number(ctx.track.scrollLeft || 0) || 0
			const span = Math.max(1, Number(ctx.track.clientWidth || 1) || 1)
			const dist = Math.abs(left - from)
			const durationMs = clamp(240 + (dist / span) * 240, 240, 520)
			try { ctx._u1Dir = left > from ? 1 : -1 } catch (_e) {}
			try { stopInertia() } catch (_e2) {}
			settleToIndex(ctx, i, { durationMs })
			try {
				if (e) { e.preventDefault(); e.stopPropagation() }
			} catch (_e3) {}
			return true
		} catch (_e4) {}
		return false
	}
	document.addEventListener('click', (e) => {
		const t = e && e.target ? e.target : null
		if (!t || !t.closest) return
		const dot = t.closest('button[data-u1-idx]')
		if (!dot) return
		goToDot(dot, e)
	}, true)

	// Fallback: en algunos browsers el section viejo captura el puntero y nunca se emite "click".
	// Si hay pointerdown sobre un dot, navegamos en pointerup.
	document.addEventListener('pointerup', (e) => {
		try {
			if (DOT.pid == null || DOT.el == null) return
			if (e.pointerId !== DOT.pid) return
			const dx = (Number(e.clientX || 0) || 0) - (Number(DOT.x || 0) || 0)
			const dy = (Number(e.clientY || 0) || 0) - (Number(DOT.y || 0) || 0)
			const dot = DOT.el
			DOT.el = null; DOT.pid = null; DOT.x = 0; DOT.y = 0
			if (Math.abs(dx) > 10 || Math.abs(dy) > 10) return
			goToDot(dot, e)
		} catch (_e0) {
			try { DOT.el = null; DOT.pid = null; DOT.x = 0; DOT.y = 0 } catch (_e1) {}
		}
	}, true)

	document.addEventListener('pointercancel', (e) => {
		try {
			if (DOT.pid == null || DOT.el == null) return
			if (e.pointerId !== DOT.pid) return
		} catch (_e0) {}
		try { DOT.el = null; DOT.pid = null; DOT.x = 0; DOT.y = 0 } catch (_e1) {}
	}, true)

	// Init: setear color-mode desde el primer render (sin esperar interacción)
	const initUiModes = () => {
		try {
			const roots = Array.from(document.querySelectorAll('.u1-pdp-customizer'))
			roots.forEach((root) => {
				const track = root.querySelector('[data-u1-pdp-gallery-track]')
				if (track) ensureUiMode(root, track)
			})
		} catch (_e) {}
	}
	try {
		if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initUiModes, { once: true })
		else initUiModes()
	} catch (_e2) {}
})()

// PDP Customizer: Mips overlay prefetch + loader for overlays
;(() => {
	const getFilesUrl = (filename) => {
		try {
			const f = String(filename || '').trim().replace(/^\//, '')
			if (!f) return ''
			const origin = String(window?.location?.origin || '').trim()
			if (!origin) return ''
			return `${origin}/cdn/shop/files/${encodeURIComponent(f)}`
		} catch (_e) {
			return ''
		}
	}

		const getOverlayPrefix = (root) => {
		try {
			const raw = String(root?.dataset?.u1PdpMipsOverlayPrefix || '').trim()
			if (raw && raw.toLowerCase() !== 'auto') return raw
		} catch (_e0) {}
		try {
			const step = root.querySelector('[data-u1-pdp-step="product_model"]')
			const sel = step ? step.querySelector('[data-u1-pdp-product-model].is-selected,[data-u1-pdp-product-model][aria-pressed="true"]') : null
			const h = sel && sel.dataset ? String(sel.dataset.u1PdpProductModelHandle || '') : ''
			const prefixFromRawModel = (raw) => {
				const s = String(raw || '').trim()
				if (!s) return ''
				// Slugify handles that may be raw variant values (e.g. "NEON Mips" → "neon-mips")
				const slug = s.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '').replace(/-+/g, '-').replace(/^-|-$/g, '')
				const base = slug.replace(/-mips$/i, '')
				if (!base) return ''
				return `pdp-${base}-mips-overlay`
			}
			if (h) {
				const p = prefixFromRawModel(h)
				if (p) return p
			}
			// MIPS sin card seleccionada (ej. PDP solo Faro MIPS / US): usar handle del producto
			if (String(root?.dataset?.u1PdpIsMips || '') === '1') {
				const ph = String(root?.dataset?.u1PdpMainProductHandle || '').trim()
				const p2 = prefixFromRawModel(ph)
				if (p2) return p2
			}
			return ''
		} catch (_e1) {}
		return ''
	}

	const buildOverlayCandidates = (prefix, ordinal) => {
		const p = String(prefix || '').trim()
		const n = Math.max(0, Math.round(Number(ordinal || 0) || 0))
		if (!p || !n) return []
		const exts = ['png', 'PNG', 'webp', 'WEBP', 'jpg', 'JPG', 'jpeg', 'JPEG']
		const out = []
		for (const ext of exts) {
			for (let suf = 0; suf <= 4; suf++) {
				const name = suf ? `${p}-${n}_${suf}.${ext}` : `${p}-${n}.${ext}`
				out.push(getFilesUrl(name))
			}
		}
		return Array.from(new Set(out.filter(Boolean)))
	}

	const prefetchMipsOverlays = (root) => {
		try {
			const enabled = String(root?.dataset?.u1PdpMipsOverlayEnabled || '') === '1'
			const isMips = String(root?.dataset?.u1PdpIsMips || '') === '1'
			if (!enabled || !isMips) return
			const prefix = getOverlayPrefix(root)
			if (!prefix) return
			for (let i = 1; i <= 4; i++) {
				const cands = buildOverlayCandidates(prefix, i)
				cands.slice(0, 4).forEach((src) => {
					try {
						const img = new Image()
						img.decoding = 'async'
						img.src = src
					} catch (_e2) {}
				})
			}
		} catch (_e3) {}
	}

	// When changing Color, the gallery DOM can re-render in phases.
	// We "freeze" Mips overlay visibility briefly to avoid fade-out/fade-in flicker.
	const armFreezeOnColorChange = (root) => {
		if (!root || root._u1MipsFreezeBound) return
		root._u1MipsFreezeBound = true
		try {
			window.addEventListener('u1:pdp:selection', (e) => {
				try {
					const d = e && e.detail ? e.detail : null
					if (!d || String(d.sectionId || '') !== String(root.dataset?.sectionId || d.sectionId || '')) {
						// fallback: match by element id suffix if available
					}
					const enabled = String(root?.dataset?.u1PdpMipsOverlayEnabled || '') === '1'
					const isMips = String(root?.dataset?.u1PdpIsMips || '') === '1'
					if (!enabled || !isMips) return
					const nextColor = d && typeof d.color === 'string' ? d.color : ''
					const prevColor = String(root._u1LastPdpColor || '')
					root._u1LastPdpColor = nextColor
					if (nextColor && nextColor !== prevColor) {
						root._u1MipsFreezeUntil = Date.now() + 420
					}
				} catch (_e0) {}
			})
		} catch (_e1) {}
	}

	const getOverlayLoaderState = (() => {
		const m = new WeakMap() // viewport -> { count, token }
		return (viewport) => {
			if (!viewport) return null
			if (!m.has(viewport)) m.set(viewport, { count: 0, token: 0 })
			return m.get(viewport)
		}
	})()

	const setViewportLoading = (viewport, on) => {
		const st = getOverlayLoaderState(viewport)
		if (!st) return
		st.count = Math.max(0, (Number(st.count || 0) || 0) + (on ? 1 : -1))
		const busy = st.count > 0
		try { viewport.classList.toggle('is-loading', busy) } catch (_e0) {}
		try { viewport.setAttribute('aria-busy', busy ? 'true' : 'false') } catch (_e1) {}
	}

	const bindOverlayLoader = (root) => {
		if (!root || root._u1MipsOverlayLoaderBound) return
		root._u1MipsOverlayLoaderBound = true
		const viewport = root.querySelector('.u1-pdp-customizer__gallery-viewport')
		if (!viewport) return

		const attach = (img) => {
			if (!img || img._u1OverlayWatch) return
			img._u1OverlayWatch = true
			let lastSrc = ''
			let token = 0
			const onSrc = () => {
				const src = String(img.getAttribute('src') || '')
				if (!src || src === lastSrc) return
				lastSrc = src
				token += 1
				const t = token
				if (img.complete && (img.naturalWidth || 0) > 0) return
				setViewportLoading(viewport, true)
				const done = () => {
					if (t !== token) return
					setViewportLoading(viewport, false)
				}
				try { img.addEventListener('load', done, { once: true }) } catch (_e0) {}
				try { img.addEventListener('error', done, { once: true }) } catch (_e1) {}
				setTimeout(done, 2500)
			}
			try {
				const mo = new MutationObserver(() => onSrc())
				mo.observe(img, { attributes: true, attributeFilter: ['src'] })
			} catch (_e2) {}
			onSrc()
		}

		// Mount per-slide overlays so they move with each slide (no mid-swipe mismatch)
		const ensureSlideOverlays = () => {
			try {
				const enabled = String(root?.dataset?.u1PdpMipsOverlayEnabled || '') === '1'
				const isMips = String(root?.dataset?.u1PdpIsMips || '') === '1'
				const ux = String(root?.getAttribute('data-u1-gallery-ux-mode') || root?.dataset?.u1GalleryUxMode || 'normal')
				const mode = String(root?.getAttribute('data-u1-gallery-mode') || root?.dataset?.u1GalleryMode || 'normal')
				// Overlay visibility should be controlled only by Model selection:
				// keep it consistent even when the gallery switches to "final" at the last step.
				const uxOk = (ux === 'normal' || ux === 'final')
				const modeOk = (mode === 'normal' || mode === 'final')
				const show = enabled && isMips && uxOk && modeOk
				const prefix = getOverlayPrefix(root)
				// Freeze is only meant to prevent flicker during normal gallery re-renders (e.g. color change).
				// Never keep overlays visible when switching UX mode (e.g. accessories/remote).
				const freeze = !!(enabled && isMips && uxOk && modeOk && Date.now() < (Number(root._u1MipsFreezeUntil || 0) || 0))
				// Cache resolved overlay srcs (prefix-ordinal -> src) to avoid flicker on gallery re-renders (e.g. color changes)
				const cache = root._u1MipsOverlaySrcCache || (root._u1MipsOverlaySrcCache = new Map())
				const setVis = (ov, on, { clearSrc } = { clearSrc: true }) => {
					if (!ov) return
					try { if (ov._u1FadeTimer) clearTimeout(ov._u1FadeTimer) } catch (_e0) {}
					ov._u1FadeTimer = null
					if (on) {
						try { ov.hidden = false } catch (_e1) {}
						try { ov.classList.remove('is-visible') } catch (_e2) {}
						try { requestAnimationFrame(() => { try { ov.classList.add('is-visible') } catch (_e3) {} }) } catch (_e4) {}
						return
					}
					try { ov.classList.remove('is-visible') } catch (_e5) {}
					ov._u1FadeTimer = setTimeout(() => {
						try { ov.hidden = true } catch (_e6) {}
						if (clearSrc) { try { ov.removeAttribute('src') } catch (_e7) {} }
					}, 190)
				}
				const setVisInstant = (ov, on) => {
					if (!ov) return
					try { if (ov._u1FadeTimer) clearTimeout(ov._u1FadeTimer) } catch (_e0) {}
					ov._u1FadeTimer = null
					if (!on) return setVis(ov, false, { clearSrc: true })
					try { ov.hidden = false } catch (_e1) {}
					// Avoid opacity animation on re-mount (prevents disappear/appear blink).
					try { ov.style.transition = 'none' } catch (_e2) {}
					try { ov.classList.add('is-visible') } catch (_e3) {}
					try { ov.style.opacity = '1' } catch (_e4) {}
					try {
						requestAnimationFrame(() => {
							try { ov.style.transition = '' } catch (_e5) {}
							try { ov.style.opacity = '' } catch (_e6) {}
						})
					} catch (_e7) {}
				}
				const prepHiddenForLoad = (ov) => {
					if (!ov) return
					try { if (ov._u1FadeTimer) clearTimeout(ov._u1FadeTimer) } catch (_e0) {}
					ov._u1FadeTimer = null
					try { ov.hidden = false } catch (_e1) {}
					try { ov.classList.remove('is-visible') } catch (_e2) {}
				}
			const showAfterLoad = (ov, { instant } = { instant: false }) => {
				if (!ov) return
				try {
					if (ov.complete && (ov.naturalWidth || 0) > 0) {
						return instant ? setVisInstant(ov, true) : setVis(ov, true, { clearSrc: false })
					}
				} catch (_e0) {}
				const token = Number(ov._u1ShowTok || 0) + 1
				ov._u1ShowTok = token
				const done = () => {
					if (Number(ov._u1ShowTok || 0) !== token) return
					instant ? setVisInstant(ov, true) : setVis(ov, true, { clearSrc: false })
				}
				try { ov.addEventListener('load', done, { once: true }) } catch (_e1) {}
					// If it errors, the error handler will try next candidate; we keep it hidden until some candidate loads.
				}

			const slides = Array.from(root.querySelectorAll('[data-u1-pdp-slide]'))
			let ord = 0
			slides.forEach((slide) => {
				if (!slide) return
				const isVid = slide.querySelector('video') != null || String(slide.getAttribute('data-u1-media') || '') === 'video'
				const isLife = String(slide.getAttribute('data-u1-lifestyle') || '') === '1'
				if (isVid || isLife) {
					try { slide.removeAttribute('data-u1-mips-ordinal') } catch (_e0) {}
					const ov = slide.querySelector('img.u1-pdp-customizer__gallery-mips-overlay[data-u1-in-slide="1"]')
					if (ov) { try { setVis(ov, false, { clearSrc: true }) } catch (_e1) {} }
					return
				}
				ord += 1
					try { slide.setAttribute('data-u1-mips-ordinal', String(ord)) } catch (_e2) {}
					const shouldHave = ord >= 1 && ord <= 4
					let ov = slide.querySelector('img.u1-pdp-customizer__gallery-mips-overlay[data-u1-in-slide="1"]')
					// Mount overlays whenever enabled for the Mips model (independent from scroll-driven gallery modes).
					if (enabled && isMips && shouldHave && !ov) {
						ov = document.createElement('img')
						ov.className = 'u1-pdp-customizer__gallery-mips-overlay'
						ov.setAttribute('data-u1-in-slide', '1')
						ov.setAttribute('alt', '')
						ov.setAttribute('aria-hidden', 'true')
						ov.decoding = 'async'
						try { ov.loading = 'eager' } catch (_e3) {}
						ov.hidden = true
					ov.addEventListener('load', () => {
						try {
							const src = String(ov.getAttribute('src') || '')
							const key = String(ov._u1CacheKey || '')
							if (src && key) cache.set(key, src)
						} catch (_eL) {}
					}, { passive: true })
					// fallback through candidate list on error
					ov.addEventListener('error', () => {
						try {
							const c = ov._u1Cands || []
							const i = Number(ov._u1CandIdx || 0) || 0
							const next = c[i + 1] || ''
							if (!next) {
								ov.hidden = true
								ov.removeAttribute('src')
								return
							}
							ov._u1CandIdx = i + 1
							ov.setAttribute('src', next)
							try {
								const key = String(ov._u1CacheKey || '')
								if (key) cache.set(key, next)
							} catch (_eC) {}
						} catch (_e4) {}
					}, { passive: true })
						slide.appendChild(ov)
					}
					if (!ov) return
					// Prefer mounting overlay inside the same square as the render image,
					// so it inherits the exact same padding/scale (no first-paint jitter).
					try {
						const sq = slide.querySelector('.u1-pdp-customizer__gallery-square')
						if (sq && ov.parentElement !== sq) sq.appendChild(ov)
					} catch (_eM) {}
					attach(ov)
					if (!show || !shouldHave) {
						// During color changes, keep overlays visible to avoid flicker while gallery re-renders.
						if (!freeze) {
							// Hide, but keep src so returning to normal is instant.
							const clear = !isMips
							try { setVis(ov, false, { clearSrc: clear }) } catch (_e5) {}
						}
						return
					}
					if (!prefix) return
					const cands = buildOverlayCandidates(prefix, ord)
					if (!cands.length) return
					const current = String(ov.getAttribute('src') || '')
					const cacheKey = `${prefix}-${ord}`
					ov._u1CacheKey = cacheKey
					const cachedSrc = cache.get(cacheKey) || ''
					const want = (cachedSrc && cands.includes(cachedSrc)) ? cachedSrc : cands[0]
					ov._u1Cands = cands
					ov._u1CandIdx = 0
					// Never show while the overlay image is still loading (prevents “scale/move” on first paint).
					// 1) set src (possibly from cache)
					// 2) keep opacity 0 until load
					prepHiddenForLoad(ov)
					// optimistic: remember chosen src so a remount can stay stable
					try { if (want) cache.set(cacheKey, want) } catch (_eK) {}
				if (current !== want) ov.setAttribute('src', want)
				// If already cached, show instantly *after* load (usually immediate from browser cache)
				showAfterLoad(ov, { instant: !!cachedSrc })
				})
			} catch (_e) {}
		}

		ensureSlideOverlays()
		try {
			const track = root.querySelector('[data-u1-pdp-gallery-track]')
			if (track) {
				const moSlides = new MutationObserver(() => ensureSlideOverlays())
				moSlides.observe(track, { childList: true, subtree: true })
			}
			const moRoot = new MutationObserver(() => ensureSlideOverlays())
			moRoot.observe(root, { attributes: true, attributeFilter: ['data-u1-pdp-is-mips', 'data-u1-gallery-ux-mode', 'data-u1-pdp-mips-overlay-prefix'] })
		} catch (_e9) {}

		// The overlay <img> is injected by the PDP customizer script; observe until it exists.
		const findAndAttach = () => {
			const img = viewport.querySelector('img.u1-pdp-customizer__gallery-mips-overlay')
			if (img) attach(img)
		}
		findAndAttach()
		try {
			const mo2 = new MutationObserver(() => findAndAttach())
			mo2.observe(viewport, { childList: true, subtree: true })
		} catch (_e3) {}
	}

	const init = () => {
		try {
			const roots = Array.from(document.querySelectorAll('.u1-pdp-customizer'))
			roots.forEach((root) => {
				bindOverlayLoader(root)
				armFreezeOnColorChange(root)
				prefetchMipsOverlays(root)
				try {
					const mo = new MutationObserver((muts) => {
						for (const m of muts) {
							if (!m || m.type !== 'attributes') continue
							if (m.attributeName === 'data-u1-pdp-is-mips') {
								const isMips = String(root?.dataset?.u1PdpIsMips || '') === '1'
								if (isMips) prefetchMipsOverlays(root)
							}
						}
					})
					mo.observe(root, { attributes: true, attributeFilter: ['data-u1-pdp-is-mips'] })
				} catch (_e0) {}
			})
		} catch (_e1) {}
	}

	try {
		if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true })
		else init()
	} catch (_e2) {}
})()

// Inside the Box: overlay on primary image (N8) when Mips model active
;(() => {
	const getFilesUrl = (filename) => {
		try {
			const f = String(filename || '').trim().replace(/^\//, '')
			if (!f) return ''
			const origin = String(window?.location?.origin || '').trim()
			if (!origin) return ''
			return `${origin}/cdn/shop/files/${encodeURIComponent(f)}`
		} catch (_e) {
			return ''
		}
	}

	const handleize = (s) =>
		String(s || '')
			.trim()
			.toLowerCase()
			.replace(/['"]/g, '')
			.replace(/[^a-z0-9]+/g, '-')
			.replace(/^-+|-+$/g, '')

	const buildCandidates = (baseName) => {
		const b = String(baseName || '').trim()
		if (!b) return []
		const exts = ['png', 'PNG', 'webp', 'WEBP', 'jpg', 'JPG', 'jpeg', 'JPEG']
		const out = []
		for (const ext of exts) {
			for (let suf = 0; suf <= 4; suf++) {
				const name = suf ? `${b}_${suf}.${ext}` : `${b}.${ext}`
				out.push(getFilesUrl(name))
			}
		}
		return Array.from(new Set(out.filter(Boolean)))
	}

	const loadFirstOk = (srcs, timeoutMs = 1600) =>
		new Promise((resolve) => {
			const list = Array.isArray(srcs) ? srcs.filter(Boolean) : []
			if (!list.length) return resolve('')
			let idx = 0
			let done = false
			const tryNext = () => {
				if (done) return
				const src = String(list[idx] || '')
				if (!src) return resolve('')
				let settled = false
				const finish = (ok) => {
					if (done || settled) return
					settled = true
					if (ok) {
						done = true
						return resolve(src)
					}
					idx += 1
					if (idx >= list.length) return resolve('')
					tryNext()
				}
				try {
					const img = new Image()
					img.decoding = 'async'
					img.addEventListener('load', () => finish(true), { once: true })
					img.addEventListener('error', () => finish(false), { once: true })
					img.src = src
					setTimeout(() => finish(false), timeoutMs)
				} catch (_e) {
					finish(false)
				}
			}
			tryNext()
		})

	const setVis = (img, on, { clearSrc } = { clearSrc: true }) => {
		if (!img) return
		try { if (img._u1FadeTimer) clearTimeout(img._u1FadeTimer) } catch (_e0) {}
		img._u1FadeTimer = null
		if (on) {
			try { img.hidden = false } catch (_e1) {}
			try { img.classList.remove('is-visible') } catch (_e2) {}
			try { requestAnimationFrame(() => { try { img.classList.add('is-visible') } catch (_e3) {} }) } catch (_e4) {}
			return
		}
		try { img.classList.remove('is-visible') } catch (_e5) {}
		img._u1FadeTimer = setTimeout(() => {
			try { img.hidden = true } catch (_e6) {}
			if (clearSrc) { try { img.removeAttribute('src') } catch (_e7) {} }
		}, 190)
	}

	const ensureItbOverlay = (host) => {
		if (!host) return null
		let img = host.querySelector('img.u1-itb-card__mips-overlay')
		if (img) return img
		img = document.createElement('img')
		// Use the same sizing rules as the base image, then layer via CSS (grid-area + z-index).
		img.className = 'u1-itb-card__img u1-itb-card__mips-overlay'
		img.setAttribute('alt', '')
		img.setAttribute('aria-hidden', 'true')
		img.decoding = 'async'
		try { img.loading = 'eager' } catch (_e0) {}
		img.hidden = true
		img.addEventListener(
			'error',
			() => {
				try {
					const c = img._u1Cands || []
					const i = Number(img._u1CandIdx || 0) || 0
					const next = c[i + 1] || ''
					if (!next) return setVis(img, false, { clearSrc: true })
					img._u1CandIdx = i + 1
					img.setAttribute('src', next)
				} catch (_e1) {}
			},
			{ passive: true }
		)
		host.appendChild(img)
		return img
	}

	const sync = (detail) => {
		try {
			const root = document.querySelector('.u1-pdp-customizer')
			if (!root) return
			const enabled = String(root.dataset?.u1PdpMipsOverlayEnabled || '') === '1'
			const isMips = String(root.dataset?.u1PdpIsMips || '') === '1'
			if (!enabled) return

			const color = detail && typeof detail.color === 'string' ? detail.color : ''
			const colorH = handleize(color)
			const productHandle = detail && typeof detail.productHandle === 'string' ? detail.productHandle : ''
			const baseHelmet = String(productHandle || '').replace(/-mips$/i, '')

			const primary = document.querySelector('.u1-itb-card--primary .u1-itb-card__media')
			if (!primary) return
			const overlay = ensureItbOverlay(primary)
			if (!overlay) return

			if (!isMips || !baseHelmet) {
				setVis(overlay, false, { clearSrc: true })
				return
			}

			// Convention (preferred): single overlay (no color)
			// pdp-<helmet>-mips-itb-overlay.png
			// Fallback (legacy): pdp-<helmet>-mips-itb-overlay-<color-handle>.png
			const baseNameNoColor = `pdp-${baseHelmet}-mips-itb-overlay`
			const candsNoColor = buildCandidates(baseNameNoColor)
			const candsByColor = colorH ? buildCandidates(`pdp-${baseHelmet}-mips-itb-overlay-${colorH}`) : []
			const cands = (candsNoColor && candsNoColor.length) ? candsNoColor : candsByColor
			if (!cands.length) {
				setVis(overlay, false, { clearSrc: true })
				return
			}
			const cur = String(overlay.getAttribute('src') || '')
			const isVisibleNow = !overlay.hidden && overlay.classList.contains('is-visible')
			const token = Number(overlay._u1SwapToken || 0) + 1
			overlay._u1SwapToken = token
			overlay._u1Cands = cands
			overlay._u1CandIdx = 0

			// If we're already visible (Mips already active) and only changing color,
			// keep opacity at 100% and swap src only after the new image is loaded.
			if (isVisibleNow) {
				loadFirstOk(cands, 1600).then((okSrc) => {
					if (Number(overlay._u1SwapToken || 0) !== token) return
					if (!okSrc) return
					if (String(overlay.getAttribute('src') || '') !== String(okSrc)) overlay.setAttribute('src', String(okSrc))
				})
				return
			}

			// First appearance (or coming back from non-mips): fade in once image is ready.
			setVis(overlay, false, { clearSrc: false })
			loadFirstOk(cands, 1600).then((okSrc) => {
				if (Number(overlay._u1SwapToken || 0) !== token) return
				if (!okSrc) return setVis(overlay, false, { clearSrc: true })
				overlay.setAttribute('src', String(okSrc))
				setVis(overlay, true, { clearSrc: false })
			})
		} catch (_e) {}
	}

	const init = () => {
		try {
			window.addEventListener('u1:pdp:selection', (e) => sync(e?.detail || null))
			// Initial sync if selection already available
			if (window.__u1PdpSelection) sync(window.__u1PdpSelection)
		} catch (_e0) {}
	}

	try {
		if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true })
		else init()
	} catch (_e1) {}
})()
